var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _path32, _g32, _path33, _g33, _path34, _g34, _path35, _g35, _path36, _g36, _path37, _g37, _path38, _g38, _path39, _g39, _path40, _g40, _path41, _g41, _path42, _g42, _path43, _g43, _path44, _g44, _path45, _g45, _path46, _g46, _path47, _g47, _path48, _g48, _path49, _g49, _path50, _g50, _path51, _g51, _path52, _g52, _path53, _g53, _path54, _g54, _path55, _g55, _path56, _g56, _path57, _g57, _path58, _g58, _path59, _g59, _path60, _g60, _path61, _g61, _path62, _g62, _path63, _g63, _path64, _g64, _path65, _g65, _path66, _g66, _path67, _g67, _path68, _g68, _path69, _g69, _path70, _g70, _path71, _g71, _path72, _g72, _path73, _g73, _path74, _g74, _path75, _g75, _path76, _g76, _path77, _g77, _path78, _g78, _path79, _g79, _path80, _g80, _path81, _g81, _path82, _g82, _path83, _g83, _path84, _g84, _path85, _g85, _path86, _g86, _path87, _g87, _path88, _g88, _path89, _g89, _path90, _g90, _path91, _g91, _path92, _g92, _path93, _g93, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticeBgStone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 34,
    width: 40,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.121 42.97c.618 0 1.081-.175.81-.45-.45-.451-2.051-.577-2.769-1 .063-.238.538-.367 1.118-.367.412 0 .881.066 1.29.204.43.143.764.334 1.193.474.366.12.758.175 1.112.175.827 0 1.453-.289 1.087-.68 1.196.362 2.206.886 2.746 1.426.077.009.146.015.203.015.927 0-.189-1.099.895-1.136h.052c.277 0 .623.072.955.146.332.072.652.143.884.143a.46.46 0 0 0 .263-.06c.332-.229-1.041-.56-1.393-.898-.237-.226.126-.35.624-.35.34 0 .738.058 1.052.181.778.3 1.021.727 1.19 1.098 1.001-.063 1.45-.529.972-1.015.956.16 1.894.504 2.437.898.063.006.12.009.175.009.686 0 .75-.446.183-.755-.612-.332-1.553-.512-2.411-.661.128-.074.329-.1.566-.1.475 0 1.107.108 1.647.18.198.026.38.037.547.037.477 0 .803-.106.886-.306-.935-.283-2.153-.415-3.06-.8.123-.012.255-.018.392-.018.964 0 2.234.263 3.255.46a.292.292 0 0 0 .083-.205c.529.257 1.278.452 1.933.466.026.003.054.003.083.003.932 0 1.467-.375 1.121-.804.524.12 1.07.183 1.562.183.254 0 .495-.017.71-.051-.55-.335-.853-.713-.845-1.036.816.055 1.605.378 2.389.62.489.152 1.112.27 1.576.27.274 0 .492-.043.586-.143.257-.275-.644-.695-1.465-.898-.308-.198.043-.338.512-.338.163 0 .344.017.515.057.652.143 1.17.424 1.802.601.266.074.584.111.847.111.36 0 .623-.074.523-.231-.06-.094-.226-.183-.392-.269a18.337 18.337 0 0 0-1.836-.8c.103-.075.258-.104.446-.104.647 0 1.71.35 2.529.566a6.46 6.46 0 0 0 1.558.204c.59 0 1.059-.103 1.17-.33.175-.354-1.035-.903-1.853-.903a1.33 1.33 0 0 0-.352.043c-.189-.155-.12-.283.08-.375.18.086.363.175.538.263.08.012.154.017.223.017.415 0 .546-.186.452-.403.458.023.932.072 1.367.072h.089l-1.814-.618a2.457 2.457 0 0 1-.294.014h-.04c-.37-.166-.795-.312-1.193-.466l.04-.054-.037-.012a1.71 1.71 0 0 1-.117.02 1.658 1.658 0 0 1-.126-.048l-1.442.251c.106.037.215.077.32.115a.575.575 0 0 0-.28.343c-.054-.017-.103-.037-.154-.055.003-.111-.049-.234-.149-.357l-1.393.24c-10.817 1.86-22.967.438-33.137 5.037.126.086.28.169.466.246.349.14.795.206 1.175.206.601 0 1.044-.16.707-.432.824.283 1.321.69 1.825 1.064.503.378 1.144.784 2.039.987.252.057.512.083.752.083Zm30.998-7.894c.53 0 .999-.118.941-.32-.515.096-1.026.19-1.536.282.12.012.238.023.355.032.08.003.16.006.24.006Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.129 42.97c.615 0 1.08-.175.805-.45-.445-.452-2.05-.577-2.766-1 .06-.238.535-.367 1.116-.367.415 0 .885.066 1.29.203.43.143.765.335 1.195.475.365.12.755.175 1.11.175.83 0 1.456-.29 1.09-.681 1.196.363 2.206.887 2.746 1.427.075.009.145.015.2.015.93 0-.185-1.099.895-1.136h.055c.275 0 .62.071.956.146.33.072.65.143.88.143.115 0 .205-.017.265-.06.33-.23-1.04-.56-1.396-.898-.235-.226.13-.35.626-.35.34 0 .74.058 1.055.181.775.3 1.02.726 1.185 1.099 1.005-.064 1.45-.53.975-1.016.955.16 1.896.503 2.436.898.065.006.12.008.175.008.685 0 .75-.446.185-.754-.615-.332-1.555-.512-2.41-.66.124-.075.324-.101.564-.101.475 0 1.106.109 1.646.18.2.026.38.037.545.037.48 0 .805-.106.89-.306-.935-.283-2.155-.414-3.06-.8.12-.012.254-.018.39-.018.965 0 2.235.264 3.255.46a.304.304 0 0 0 .085-.206 4.976 4.976 0 0 0 2.016.47c.93 0 1.465-.375 1.12-.804.525.12 1.07.183 1.56.183.255 0 .495-.017.71-.052-.55-.334-.85-.712-.845-1.035.815.055 1.605.378 2.39.62.49.152 1.11.27 1.576.27.275 0 .49-.043.585-.143.26-.275-.64-.695-1.465-.898-.305-.198.045-.338.515-.338.16 0 .34.017.515.058.65.142 1.17.423 1.8.6.265.074.585.111.846.111.36 0 .625-.074.525-.231-.06-.094-.225-.183-.39-.269-.56-.283-1.18-.555-1.84-.801.104-.074.26-.103.45-.103.644 0 1.71.349 2.525.566a6.474 6.474 0 0 0 1.56.204c.59 0 1.06-.103 1.17-.33.175-.354-1.035-.903-1.855-.903-.125 0-.245.014-.35.043-.19-.155-.12-.283.08-.375.18.086.365.175.535.263.08.011.155.017.225.017.415 0 .545-.186.45-.403.46.023.935.072 1.37.072h.09l-1.815-.618a2.43 2.43 0 0 1-.295.014h-.04c-.37-.166-.795-.312-1.19-.466l.04-.055-.04-.011a1.49 1.49 0 0 1-.115.02c-.045-.014-.085-.032-.125-.049-.485.087-.966.169-1.446.252l.32.114a.59.59 0 0 0-.28.344c-.055-.017-.1-.037-.155-.054.005-.112-.045-.235-.145-.358l-1.395.24c-10.817 1.86-22.965.438-33.137 5.037.125.086.28.169.465.246.35.14.795.206 1.176.206.6 0 1.045-.16.71-.432.82.283 1.32.69 1.82 1.064.505.378 1.145.784 2.04.987.256.057.516.083.756.083Zm30.996-7.895c.53 0 1-.117.94-.32-.515.097-1.025.192-1.535.283.12.012.235.023.355.032.08.002.16.005.24.005Z",
    fill: "#5C9518"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 99,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.167 40.809c10.17-4.6 22.32-3.178 33.137-5.037l1.393-.24a1.233 1.233 0 0 0-.203-.2c.157.048.312.102.466.154.478-.083.959-.166 1.442-.252a4.038 4.038 0 0 1-.63-.317c.095-.012.198-.015.3-.015.45 0 .965.078 1.462.129.51-.092 1.021-.186 1.536-.283a.273.273 0 0 0-.083-.115c-.337-.3-1.25-.386-1.956-.469-.706-.083-1.687-.437-1.373-.638.083.01.163.012.235.012 1.095 0 1.055-.827-.183-1.124-.252-.06-.518-.097-.75-.177-1.415-.487.864-1.322-.646-1.722a2.107 2.107 0 0 0-.532-.069c-.28 0-.54.052-.798.103a3.973 3.973 0 0 1-.787.103 1.91 1.91 0 0 1-.563-.083c-.526-.16-.62-.455-.455-.638.166-.18.5-.32.518-.535.02-.266-.52-.612-1.198-.763a3.39 3.39 0 0 0-.761-.086c-.395 0-.724.074-.856.212a1.036 1.036 0 0 1-.526-.178c.39-.183.687-.506 1.356-.506l.06.003c1.805.051 1.936 1.819 3.801 1.97.755-.122-.703-.829-.32-1.12.086-.064.24-.09.429-.09.355 0 .83.095 1.192.218.558.192 1.036.446 1.642.59.023.002.049.002.072.002.886 0 .286-.68-.59-1.018-.9-.346-2.136-.77-1.984-1.147.883.109 1.761.18 2.608.212.031-.367-1.107-.841-1.968-.841-.034 0-.066 0-.097.003.432-.295 1.204-.47 1.525-.801.317-.33-.135-.936-1.159-1.119a3.658 3.658 0 0 0-.67-.054c-.305 0-.6.023-.906.026h-.02c-.517 0-1.255-.132-1.453-.366-.372-.444 1.536-.238 1.942-.55.644-.497-2.714-1.198-2.877-1.867.172.017.34.025.5.025.472 0 .881-.074 1.122-.214a15.149 15.149 0 0 0-3.587-.63c-.132-.494.632-.857 1.753-.857.078 0 .155.003.235.005h.031c.976 0 .798-.695-.206-.995a3.883 3.883 0 0 0-1.107-.16c-.62 0-1.135.154-1.25.4-.117-.423.484-.706 1.096-.938.612-.232 1.29-.466 1.376-.858.083-.395-.767-.99-1.79-1.078l-.524.866a.507.507 0 0 1-.18.029c-.355 0-.876-.237-1.033-.429-.189-.229-.286-.5-.795-.655a1.854 1.854 0 0 0-.523-.077c-.4 0-.735.134-.941.269a4.955 4.955 0 0 0-1.244-.47 1.043 1.043 0 0 0-.158-.01c-.477 0-.492.317-.22.557.297.266.772.572.572.772-.08.08-.263.126-.492.126h-.011a2.225 2.225 0 0 1-1.041-.277l-.006-.063c-.04-.186-.258-.407-.572-.592-.026-.31.131-.601-.203-.924-.258-.252-1.038-.472-1.516-.472-.203 0-.349.037-.383.131.083-.44-.083-.992-1.056-1.396-.383-.157-.875-.231-1.298-.231-.65 0-1.127.171-.77.466a5.155 5.155 0 0 1-1.166-.58.404.404 0 0 0 .157-.22c-.189-.03-.378-.05-.567-.07l-.388-.297c-.45-.343-1.007-.706-1.742-.95.772-.168-.066-.898-1.139-1.043a3.213 3.213 0 0 0-.454-.032c-.816 0-1.307.332-1.093.712-.512-.434-.343-.85-.112-1.21.235-.357.515-.735.183-1.172-.306-.406-1.384-.855-2.23-.855a1.72 1.72 0 0 0-.212.011c.16.343.317.686.475 1.03-.035.054-.129.077-.252.077-.309 0-.806-.14-1.072-.292l-.13-.077a12.018 12.018 0 0 1 1.5 6.575v.01c0 .013 0 .025-.003.04v.025c0 .009-.003.017-.003.023-.02.277-.049.552-.089.823v.02a.102.102 0 0 0-.006.032c-.002.011-.002.023-.005.034 0 .003 0 .009-.003.012 0 .017-.003.034-.006.051v.003c-.097.604-.24 1.198-.438 1.773-.509 1.493-1.172 2.34-2.113 3.135.254.066.532.126.84.169 1.911.555 4.465.82 5.858 2.694-3.017.535-5.571 1.605-8.357 2.406-1.825.497-3.704.532-5.574.532h-.959c-1.847 0-3.683.034-5.454.512-.715.154-1.439.34-2.174.563-1.882.578-3.764.764-5.66.764-1.616 0-3.243-.135-4.89-.28-.824.031-1.648.054-2.472.074-2.059.046-4.127.066-6.19.117-.688.017-1.375.04-2.064.069-1.31.137-2.606.263-3.893.263-1.759 0-3.5-.235-5.242-1.007-.58-.24-1.144-.495-1.702-.76-.186.271-.707.463-1.23.62-.672.206-1.413.409-1.57.787-.158.377.603.984 1.642 1.104l.694-.824a.52.52 0 0 1 .166-.023c.364 0 .878.255 1.007.449.152.229.2.495.695.66.2.07.398.095.587.095.383 0 .726-.114.952-.232.306.195.726.37 1.19.498.071.009.137.014.194.014.458 0 .524-.297.295-.534-.258-.266-.69-.575-.446-.764.088-.069.263-.109.474-.109.02 0 .043 0 .066.003.813.032 1.479.53 1.496.864.017.335-.277.635.032.992.228.264 1.032.51 1.521.51.183 0 .32-.035.366-.118-.163.423-.097.964.827 1.384.4.184.955.27 1.416.27.603 0 1.046-.15.752-.427.86.332 1.327.778 1.805 1.193.477.418 1.104.872 2.062 1.121.317.083.658.123.966.123.627 0 1.102-.163.873-.443-.398-.495-2.168-.692-2.878-1.167.115-.223.595-.338 1.173-.338.506 0 1.09.086 1.573.27.446.165.781.382 1.23.545.432.16.924.232 1.364.232.861 0 1.53-.269 1.224-.672 1.262.432 2.274 1.024 2.76 1.613.103.014.195.023.272.023.48 0 .484-.289.518-.578.034-.286.097-.575.692-.575h.011c.653.003 1.574.384 2.103.384a.564.564 0 0 0 .266-.055c.426-.229-1.041-.635-1.359-1-.149-.172.02-.278.323-.324.258.114.54.212.855.283.252.057.512.083.75.083.097 0 .189-.006.277-.014.567.326.712.718.801 1.067 1.141-.026 1.753-.498 1.333-1.027 1.035.206 2.008.606 2.528 1.044.066.008.129.011.19.014-.287.123-.693.195-1.168.195-.06 0-.123 0-.186-.003h-.02c-.9 0-.72.643.206.915.332.097.678.143.993.143.577 0 1.05-.146 1.15-.377.117.391-.421.655-.973.869-.555.217-1.167.438-1.233.798-.066.363.724.91 1.662.987.151-.27.303-.538.455-.804a.5.5 0 0 1 .169-.026c.32 0 .8.215.949.39.177.21.272.46.74.6.167.049.324.069.473.069.369 0 .672-.126.858-.252.309.172.715.323 1.147.426.051.006.097.009.14.009.44 0 .446-.292.191-.515-.28-.243-.72-.52-.543-.71.072-.074.24-.117.455-.117h.003c.72 0 1.407.45 1.487.767.08.314-.123.606.223.935.24.229.952.426 1.387.426.189 0 .326-.034.355-.123-.052.32.043.71.532 1.036Zm-11.138-7.3a.848.848 0 0 1 .275.25c-.252-.058-.51-.115-.76-.167.125-.054.29-.08.485-.083Zm-32.313-5.262c.403 0 .766-.063 1-.175-.66-.317-1.31-.646-1.959-.975-.088-.003-.18-.006-.271-.015h-.1c-.933 0-.858.655.097.973.397.131.835.192 1.233.192Zm-5.037-2.655c.292 0 .55-.034.72-.1a24.331 24.331 0 0 0-2.339-.864c-1.393-.534-.463-2.139.235-2.405 1.739-.644 3.478-.981 5.216-1.15-.148-1.547.075-3.298.398-4.722a7.962 7.962 0 0 1 .558-1.636c.452-.973 1.055-1.765 1.71-2.531.384-.45.784-.887 1.179-1.348.797-.93 1.444-2.053 2.087-3.174.238-.415.475-.833.718-1.239v.003c.695-1.153 1.445-2.225 2.426-2.989.638-.495 1.315-.79 2.008-1.032.506-.178 1.02-.326 1.533-.5-.778-.201-1.476-.513-2.154-.799-.82-.349-1.793-.706-2.76-.775a2.672 2.672 0 0 0-.212-.009c-.85 0-1.375.387-.703.738.855.446 2.334.292 3.386.655.275.398-.323.707-1.184.707-.206 0-.432-.02-.66-.057-.51-.09-.999-.252-1.508-.335a3.424 3.424 0 0 0-.57-.049c-1.092 0-1.627.58-.731 1.064-1.393-.203-2.798-.629-3.824-1.161-1.242.057 1.198 1.264.271 1.527a1.649 1.649 0 0 1-.443.046c-.186 0-.389-.014-.59-.026a8.163 8.163 0 0 0-.557-.025c-.263 0-.449.031-.46.146-.029.334 1.475.463 2.127.795.587.294.08.58-.64.58-.186 0-.383-.02-.584-.063-.972-.206-1.627-.663-2.168-1.07-.772.264-.652.899.266 1.382a8.567 8.567 0 0 1-2.997-.595c-.795.066-.372.67.495.947.866.275 1.847.306 2.725.323-.091.33-1.146.298-1.939.326-.758.026-1.107.25-.918.587 1.09.157 2.245.08 3.418.363-.415.169-1.107.214-1.848.214-.563 0-1.155-.025-1.678-.045a.548.548 0 0 0 .148.257 5.998 5.998 0 0 0-1.561-.229c-.2 0-.39.017-.555.049-.85.157-.924.72-.158 1.17a6.845 6.845 0 0 0-.477-.018c-.658 0-1.224.106-1.565.298.815.289 1.473.675 1.81 1.061a2.96 2.96 0 0 1-.362.02c-.69 0-1.528-.186-2.3-.3a6.895 6.895 0 0 0-.961-.075c-.578 0-1.032.098-.984.338.074.369 1.276.695 2.185.78.592.221.198.53-.432.53-.043 0-.085 0-.131-.006-.7-.046-1.433-.274-2.151-.363a2.898 2.898 0 0 0-.349-.023c-.58 0-1.038.18-.67.423.147.098.384.175.61.24.775.23 1.582.43 2.397.598-.017.18-.298.244-.704.244-.632 0-1.564-.146-2.285-.224a5.703 5.703 0 0 0-.618-.034c-.987 0-1.759.263-1.536.698.2.386 1.396.746 2.168.746.275 0 .495-.045.598-.151.62.283.36.643-.192.772-.554.126-1.315.132-1.799.292-.483.163-.457.61.292.812.2.054.398.077.58.077.381 0 .707-.097.902-.217.291-.177.506-.406 1.06-.443.027-.003.055-.003.087-.003.56 0 1.398.323 1.14.498.564-.387 1.176-.53.742-1.173 1.944.309 3.086 1.679 1.819 2.008a1.384 1.384 0 0 1-.326.031c-.24 0-.53-.034-.819-.068a6.838 6.838 0 0 0-.818-.072c-.317 0-.549.06-.594.263-.06.283.9.778 1.61.778.131 0 .254-.017.36-.054-.306-.155-.031-.266.34-.266.207 0 .444.034.627.117.51.229.523.518.558.77.014.1.057.211.137.317-.429-.046-.91-.134-1.23-.134-.177 0-.306.028-.355.103-.185.303 1.342.546 1.882.898.43.283-.051.486-.697.486-.27 0-.567-.035-.838-.115-.933-.268-1.416-.737-1.797-1.152-.94.177-1.107.763-.36 1.278-1.024-.086-2.137-.389-2.894-.79H2.21c-.858 0-.69.581.097.902.79.323 1.81.434 2.732.52-.129.152-.48.192-.91.192-.406 0-.878-.037-1.293-.057-.074-.003-.145-.006-.214-.006-.68 0-1.067.175-1.027.463 1.076.235 2.337.26 3.447.615-.28.066-.627.089-1.013.089-.866 0-1.919-.129-2.797-.226-.094.329.432.758 1.35.984-.283.034-.566.072-.85.106.155.046.315.08.464.1-.106.049-.215.094-.32.143.217.189.586.357 1 .486.118.232.36.463.804.664.4.183.956.269 1.416.269.603 0 1.047-.15.752-.427.861.332 1.327.778 1.805 1.193.478.418 1.104.873 2.062 1.121.318.083.658.123.964.123ZM40.942 9.635a9.74 9.74 0 0 0 .63-1.104c.134-.274.25-.549.365-.824.266-.643.512-1.272.893-1.847l.066-.095c.034-.051.071-.1.108-.151l.06-.072c.166-.211.346-.403.532-.586a2.993 2.993 0 0 0-.24-.043 3.688 3.688 0 0 0-.455-.031c-.812 0-1.304.331-1.092.715-.512-.438-.34-.85-.11-1.21.236-.36.513-.735.184-1.176-.306-.403-1.384-.852-2.23-.852-.072 0-.144.003-.213.008l.475 1.033c-.034.054-.129.077-.252.077-.308 0-.806-.14-1.072-.292-.372-.214-.72-.492-1.261-.566a1.77 1.77 0 0 0-.232-.017c-.49 0-.66.26-.69.483l-.162-.051a31.88 31.88 0 0 1 1.018 1.65c.04.072.083.143.123.215 1.004 1.727 2.282 3.329 3.555 4.736ZM27.348 1.824a9.52 9.52 0 0 0 .692-.283c.152-.072.306-.143.46-.218-.065-.005-.131-.005-.194-.005-.68 0-1.184.237-.958.506Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.166 40.808c10.17-4.6 22.325-3.178 33.139-5.037l1.395-.24a1.293 1.293 0 0 0-.204-.2c.155.048.31.103.466.154l1.443-.252a3.945 3.945 0 0 1-.633-.317c.097-.012.199-.014.3-.014.451 0 .966.077 1.465.128.51-.091 1.02-.186 1.534-.283a.28.28 0 0 0-.08-.114c-.338-.3-1.25-.386-1.958-.47-.708-.082-1.69-.437-1.373-.637.08.008.16.011.236.011 1.094 0 1.051-.826-.183-1.124-.252-.06-.52-.097-.75-.177-1.417-.486.863-1.322-.65-1.722a2.07 2.07 0 0 0-.53-.068c-.28 0-.542.051-.8.103a3.975 3.975 0 0 1-.783.103 1.9 1.9 0 0 1-.563-.084c-.526-.16-.623-.455-.456-.637.166-.18.499-.32.515-.535.021-.266-.52-.612-1.197-.764a3.39 3.39 0 0 0-.761-.086c-.392 0-.724.075-.853.212a1.027 1.027 0 0 1-.526-.177c.387-.183.687-.507 1.352-.507.022 0 .043.003.064.003 1.803.052 1.937 1.82 3.798 1.97.757-.122-.703-.829-.316-1.12.085-.063.236-.09.423-.09.36 0 .832.095 1.197.218.557.192 1.035.447 1.641.59a.6.6 0 0 0 .07.002c.89 0 .29-.68-.59-1.018-.901-.346-2.135-.77-1.985-1.147.885.109 1.765.18 2.612.212.027-.366-1.11-.84-1.968-.84-.038 0-.065 0-.097.002.43-.295 1.202-.47 1.523-.801.317-.329-.134-.936-1.158-1.119a3.68 3.68 0 0 0-.67-.054c-.306 0-.601.023-.907.026h-.022c-.515 0-1.255-.132-1.448-.366-.375-.443 1.534-.237 1.942-.549.644-.498-2.714-1.198-2.88-1.868.171.017.343.026.498.026.472 0 .885-.075 1.121-.215a15.113 15.113 0 0 0-3.583-.629c-.134-.495.633-.858 1.754-.858.075 0 .15.002.23.006h.033c.976 0 .8-.695-.204-.996a3.888 3.888 0 0 0-1.105-.16c-.622 0-1.137.155-1.25.4-.118-.423.483-.706 1.095-.938.611-.232 1.287-.466 1.373-.857.086-.395-.767-.99-1.792-1.08-.171.29-.349.578-.52.868a.518.518 0 0 1-.183.028c-.353 0-.874-.237-1.03-.428-.187-.23-.29-.502-.793-.655a1.878 1.878 0 0 0-.526-.078c-.402 0-.735.134-.939.269a4.978 4.978 0 0 0-1.244-.47 1.108 1.108 0 0 0-.161-.01c-.477 0-.488.317-.22.557.3.266.772.572.574.772-.08.08-.263.126-.493.126h-.011a2.235 2.235 0 0 1-1.04-.277l-.006-.063c-.043-.186-.258-.407-.574-.592-.027-.309.134-.6-.204-.924-.257-.252-1.035-.472-1.513-.472-.204 0-.348.037-.386.132.086-.44-.08-.993-1.051-1.396-.387-.157-.88-.232-1.298-.232-.655 0-1.132.172-.773.466a5.092 5.092 0 0 1-1.164-.58c.08-.066.14-.14.156-.22-.188-.03-.381-.049-.569-.07-.129-.1-.257-.2-.386-.296-.45-.344-1.008-.707-1.743-.95.772-.169-.065-.898-1.138-1.044a3.247 3.247 0 0 0-.456-.031c-.815 0-1.308.331-1.094.711-.51-.434-.343-.849-.107-1.21.23-.357.515-.734.182-1.172-.305-.406-1.384-.855-2.231-.855-.075 0-.145.003-.215.011.161.344.322.687.478 1.03-.038.054-.129.077-.252.077-.312 0-.805-.14-1.073-.292l-.129-.077a12.105 12.105 0 0 1 1.513 5.34c.016.41.01.824-.016 1.236v.075c0 .008-.006.017-.006.022-.016.277-.048.552-.086.824v.02c-.005.008-.005.02-.005.031-.005.012-.005.023-.005.035 0 .002 0 .008-.006.011 0 .017 0 .034-.005.051v.003a10.53 10.53 0 0 1-.44 1.774c-.504 1.493-1.17 2.34-2.113 3.134.257.066.536.127.842.17 1.91.554 4.468.82 5.857 2.694-3.014.535-5.567 1.604-8.357 2.405-1.824.498-3.701.532-5.573.532h-.96c-1.846 0-3.68.034-5.45.512-.719.154-1.443.34-2.178.563-1.883.578-3.76.764-5.659.764-1.615 0-3.245-.134-4.892-.28-.82.031-1.647.054-2.468.074-2.06.046-4.13.066-6.19.118-.692.017-1.378.04-2.065.068-1.309.138-2.607.263-3.894.263-1.76 0-3.503-.234-5.24-1.007-.58-.24-1.149-.494-1.701-.76-.188.272-.708.463-1.234.62-.67.206-1.41.41-1.572.787-.155.377.607.983 1.647 1.104l.692-.824a.532.532 0 0 1 .166-.023c.365 0 .88.255 1.009.45.15.228.198.494.692.66.204.069.397.094.59.094.38 0 .724-.114.95-.231.305.194.729.369 1.19.497.07.01.14.014.193.014.462 0 .526-.297.295-.534-.257-.266-.686-.575-.445-.764.086-.068.263-.109.472-.109.021 0 .043 0 .07.004.81.03 1.475.529 1.496.863.016.335-.279.635.027.993.23.263 1.035.509 1.524.509.182 0 .321-.035.364-.118-.16.424-.096.964.826 1.385.403.183.96.268 1.417.268.606 0 1.05-.148.756-.425.858.331 1.325.777 1.802 1.192.478.418 1.105.873 2.065 1.122a3.9 3.9 0 0 0 .966.123c.628 0 1.1-.164.869-.444-.397-.495-2.167-.692-2.875-1.167.112-.223.595-.337 1.174-.337.505 0 1.09.086 1.572.269.445.165.778.383 1.228.546.435.16.923.231 1.363.231.864 0 1.534-.268 1.228-.672 1.26.432 2.275 1.024 2.758 1.613.101.015.193.023.273.023.477 0 .483-.289.515-.578.037-.285.102-.575.692-.575h.016c.65.004 1.572.384 2.097.384a.568.568 0 0 0 .269-.055c.423-.228-1.041-.634-1.358-1-.15-.172.022-.278.322-.324.258.115.542.212.853.284.252.056.515.082.751.082.097 0 .188-.005.28-.014.562.326.712.718.798 1.067 1.143-.026 1.754-.498 1.336-1.027 1.035.206 2.006.607 2.526 1.044.065.009.13.012.188.014-.284.123-.692.195-1.164.195-.064 0-.123 0-.188-.003h-.021c-.901 0-.719.644.21.916.326.097.675.142.992.142.574 0 1.046-.146 1.148-.377.117.392-.419.655-.971.87-.558.217-1.17.437-1.234.797-.064.364.724.91 1.663.987l.45-.804a.522.522 0 0 1 .172-.026c.322 0 .8.215.95.39.176.211.273.46.74.6.166.049.322.069.472.069.37 0 .67-.126.858-.252.311.172.713.323 1.148.426.048.006.096.009.14.009.44 0 .444-.292.192-.515-.284-.243-.724-.52-.547-.71.075-.073.242-.116.456-.116h.006c.718 0 1.405.449 1.485.766.08.315-.123.606.226.935.236.23.95.427 1.384.427.187 0 .327-.035.354-.124-.049.32.043.71.53 1.036Zm-11.136-7.3a.842.842 0 0 1 .273.25c-.252-.058-.51-.115-.761-.166.128-.055.295-.08.488-.084Zm-32.313-5.262c.402 0 .767-.063 1.003-.175-.665-.317-1.314-.646-1.963-.975-.086-.003-.177-.006-.269-.014h-.101c-.934 0-.859.655.096.972.397.132.837.192 1.234.192Zm-5.037-2.654c.29 0 .547-.035.719-.1a23.9 23.9 0 0 0-2.339-.864c-1.39-.535-.461-2.14.236-2.406 1.738-.643 3.476-.98 5.22-1.15-.151-1.547.069-3.297.396-4.722a7.532 7.532 0 0 1 .558-1.636c.45-.972 1.051-1.764 1.706-2.53.386-.45.788-.887 1.18-1.348.8-.93 1.443-2.054 2.086-3.175.242-.415.478-.832.72-1.238v.002c.697-1.153 1.448-2.225 2.424-2.989.638-.494 1.32-.789 2.011-1.032.505-.177 1.02-.326 1.53-.5-.779-.2-1.476-.513-2.152-.798-.82-.35-1.791-.707-2.762-.776a2.483 2.483 0 0 0-.21-.008c-.847 0-1.373.386-.702.737.853.447 2.333.292 3.385.655.273.398-.322.707-1.186.707-.204 0-.43-.02-.66-.057-.51-.09-.997-.252-1.507-.335a3.402 3.402 0 0 0-.569-.049c-1.094 0-1.625.581-.73 1.065-1.394-.204-2.8-.63-3.824-1.162-1.244.058 1.196 1.265.268 1.528a1.611 1.611 0 0 1-.44.046c-.187 0-.391-.015-.59-.026a8.136 8.136 0 0 0-.557-.026c-.263 0-.45.031-.462.146-.026.334 1.476.463 2.13.795.585.295.08.58-.644.58-.182 0-.38-.02-.58-.062-.975-.206-1.63-.664-2.171-1.07-.773.263-.65.898.268 1.381a8.566 8.566 0 0 1-2.999-.595c-.794.066-.37.67.494.947.869.275 1.85.306 2.73.323-.091.33-1.148.298-1.942.326-.756.026-1.105.25-.917.587 1.089.157 2.242.08 3.417.363-.413.169-1.105.215-1.845.215-.564 0-1.159-.026-1.68-.046a.526.526 0 0 0 .146.257 5.978 5.978 0 0 0-1.561-.229c-.199 0-.387.018-.553.049-.853.157-.923.721-.16 1.17a6.874 6.874 0 0 0-.478-.017c-.655 0-1.223.105-1.561.297.815.29 1.47.675 1.807 1.062-.112.013-.236.02-.359.02-.692 0-1.529-.187-2.301-.301a6.932 6.932 0 0 0-.96-.074c-.58 0-1.036.097-.987.337.075.37 1.276.695 2.188.78.59.221.193.53-.434.53-.043 0-.086 0-.129-.006-.703-.045-1.438-.274-2.15-.363a2.906 2.906 0 0 0-.35-.023c-.584 0-1.04.18-.67.423.145.098.38.175.606.24.778.23 1.582.43 2.398.599-.016.18-.295.243-.703.243-.633 0-1.566-.146-2.285-.223a5.666 5.666 0 0 0-.617-.035c-.987 0-1.76.264-1.534.698.198.387 1.395.747 2.167.747.274 0 .494-.046.595-.152.623.283.36.644-.193.773-.552.125-1.314.131-1.797.291-.482.163-.456.61.29.813.204.054.402.077.585.077.38 0 .702-.097.9-.218.29-.177.505-.406 1.058-.443.026-.003.059-.003.085-.003.564 0 1.4.323 1.143.498.563-.386 1.175-.53.74-1.173 1.947.309 3.09 1.679 1.819 2.008a1.36 1.36 0 0 1-.322.031c-.242 0-.531-.034-.82-.068a6.926 6.926 0 0 0-.816-.072c-.322 0-.553.06-.596.264-.059.282.901.777 1.61.777.128 0 .252-.017.359-.054-.306-.154-.032-.266.343-.266.204 0 .44.035.623.117.51.23.525.518.557.77.016.1.06.211.14.317-.43-.046-.912-.134-1.229-.134-.177 0-.305.028-.359.103-.182.303 1.346.546 1.883.898.429.283-.048.486-.697.486-.269 0-.564-.034-.837-.114-.934-.27-1.416-.738-1.797-1.153-.939.177-1.105.764-.36 1.279-1.024-.086-2.135-.39-2.896-.79H2.21c-.858 0-.687.58.097.901.793.323 1.813.435 2.735.52-.128.152-.483.192-.912.192-.407 0-.88-.037-1.292-.057-.075-.002-.145-.006-.215-.006-.681 0-1.067.175-1.024.464 1.072.234 2.333.26 3.443.614-.279.066-.627.09-1.014.09-.863 0-1.915-.13-2.794-.227-.097.329.429.758 1.352.985-.285.034-.569.07-.853.105.155.046.316.08.466.1-.107.049-.214.094-.322.143.215.189.585.358.998.487.118.23.365.463.805.663.402.183.955.269 1.416.269.606 0 1.046-.15.75-.426.864.332 1.331.778 1.809 1.193.477.417 1.105.872 2.06 1.12.321.084.66.123.965.123ZM40.944 9.634c.134-.204.263-.415.386-.64.08-.15.166-.304.242-.464.134-.275.252-.55.364-.824.269-.644.515-1.273.896-1.848l.065-.094c.032-.052.07-.1.107-.152a5.963 5.963 0 0 1 .595-.658 3.45 3.45 0 0 0-.697-.074c-.81 0-1.304.331-1.094.715-.51-.438-.338-.85-.108-1.21.236-.36.515-.735.183-1.176-.306-.403-1.384-.852-2.232-.852-.07 0-.14.003-.209.009.156.346.316.689.472 1.032-.032.054-.129.078-.247.078-.31 0-.81-.14-1.073-.292-.375-.215-.724-.492-1.265-.567a1.773 1.773 0 0 0-.231-.017c-.488 0-.66.26-.687.483-.053-.017-.112-.033-.166-.051.37.547.703 1.113 1.02 1.65.042.072.085.144.123.215 1.003 1.728 2.285 3.33 3.556 4.737ZM27.351 1.823c.231-.086.462-.177.692-.283.15-.071.306-.143.456-.217-.064-.006-.128-.006-.193-.006-.681 0-1.185.238-.955.506Z",
    fill: "#5C9518"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 23,
    width: 9,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.874 28.161a.379.379 0 0 0 .069-.252.55.55 0 0 1-.23.175l.161.077Zm-1.976-1.05c.609 0 1.12-.105 1.438-.28a1.25 1.25 0 0 0-.08-.049 11.23 11.23 0 0 1-.686-.577 14.621 14.621 0 0 1-2.457-.598c.243-.112.615-.169 1.038-.169.117 0 .24.003.366.015a.415.415 0 0 1-.043-.183.984.984 0 0 0-.002-.184 6.273 6.273 0 0 0-.744-.394 3.894 3.894 0 0 1-.626-.092l-.595.624a1.23 1.23 0 0 1-.106.005c-.624 0-1.29-.446-1.244-.723.034-.2.24-.37.323-.558l-.06-.023a4.64 4.64 0 0 0-1.573-.269c-.578 0-1.059.115-1.173.338.71.477 2.48.675 2.877 1.167.123.151.043.266-.154.343 1.155.492 2.257 1.047 3.358 1.605.048.002.094.002.143.002Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.873 28.161a.361.361 0 0 0 .069-.252.575.575 0 0 1-.228.175l.159.077Zm-1.976-1.05c.611 0 1.12-.105 1.44-.28a1.103 1.103 0 0 0-.08-.049c-.213-.16-.446-.357-.69-.577a14.68 14.68 0 0 1-2.454-.598c.244-.112.616-.169 1.036-.169.116 0 .244.003.366.015a.495.495 0 0 1-.043-.184 1.056 1.056 0 0 0 0-.183 6.84 6.84 0 0 0-.743-.394 3.81 3.81 0 0 1-.627-.092c-.202.209-.398.418-.595.624-.037.002-.069.006-.106.006-.626 0-1.29-.447-1.248-.724.037-.2.245-.37.324-.558l-.058-.023a4.638 4.638 0 0 0-1.572-.269c-.58 0-1.057.115-1.174.338.712.478 2.48.675 2.879 1.166.122.152.042.267-.154.344 1.152.492 2.257 1.047 3.356 1.604.048.003.096.003.143.003Z",
    fill: "url(#d)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 21,
    width: 64,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.818 29.925c1.287 0 2.583-.126 3.892-.263.69-.029 1.376-.052 2.066-.069 2.062-.052 4.13-.072 6.189-.117.824-.02 1.647-.043 2.471-.075 1.647.146 3.275.28 4.89.28 1.897 0 3.78-.185 5.661-.763a27.355 27.355 0 0 1 2.174-.563c1.77-.478 3.606-.512 5.454-.512h.958c1.87 0 3.75-.035 5.575-.532 2.785-.801 5.34-1.871 8.357-2.406-1.393-1.873-3.947-2.14-5.858-2.694a7.393 7.393 0 0 1-.84-.169c-.106.092-.218.18-.332.269.111.08.22.177.331.297 1.127.693 4.843.693 3.681 1.493-5.34 3.21-12.072 2.143-18.445 3.09-.763.1-1.527.188-2.288.271-3.049.32-6.089.492-9.115.564-.77.037-1.533.068-2.3.097-1.91.071-3.818.109-5.726.183-.634.026-1.27.054-1.904.091-1.519.192-3.08.35-4.648.35-2.626 0-5.265-.444-7.725-1.92-.318.175-.83.28-1.439.28-.049 0-.094 0-.143-.002.65.329 1.299.657 1.96.975a.552.552 0 0 0 .228-.174.379.379 0 0 1-.069.251c.558.266 1.122.52 1.702.761 1.742.772 3.484 1.007 5.243 1.007ZM15.569 26.2c-1.381-1.25-3.052-3.29-1.867-3.97.291-.198.589-.372.89-.524a8.54 8.54 0 0 1-.084-.626c-1.739.169-3.478.506-5.217 1.15-.698.266-1.627 1.87-.234 2.405.812.252 1.587.544 2.34.864.197-.077.277-.192.154-.343-.398-.492-2.168-.69-2.878-1.167.115-.223.595-.338 1.173-.338.506 0 1.09.086 1.573.27l.06.022c-.083.189-.289.358-.323.558-.046.277.62.724 1.244.724.037 0 .072-.003.106-.006l.595-.624c.206.049.418.078.626.092.28.131.544.263.744.395a.983.983 0 0 1 .003.183.416.416 0 0 0 .043.183 4.01 4.01 0 0 0-.366-.015c-.424 0-.796.057-1.039.169a14.61 14.61 0 0 0 2.457.598Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.816 29.925c1.291 0 2.582-.126 3.895-.263.69-.029 1.376-.052 2.066-.069 2.062-.051 4.129-.072 6.19-.117.824-.02 1.647-.043 2.47-.075 1.648.147 3.274.281 4.889.281 1.896 0 3.777-.186 5.663-.764a27.14 27.14 0 0 1 2.173-.563c1.77-.478 3.608-.512 5.451-.512h.963c1.87 0 3.745-.034 5.572-.532 2.785-.801 5.34-1.87 8.358-2.405-1.392-1.874-3.948-2.14-5.86-2.695a7.434 7.434 0 0 1-.84-.169c-.106.092-.218.18-.33.27.112.08.219.176.33.297 1.127.692 4.84.692 3.682 1.493-5.34 3.209-12.071 2.142-18.447 3.089-.765.1-1.524.188-2.284.271-3.05.32-6.094.492-9.117.564-.77.037-1.536.068-2.301.097-1.913.072-3.82.108-5.727.183-.633.026-1.27.055-1.902.092-1.52.191-3.082.348-4.65.348-2.624 0-5.265-.443-7.724-1.919-.32.175-.83.28-1.44.28-.048 0-.096 0-.144-.002.654.329 1.302.658 1.96.975a.54.54 0 0 0 .23-.174.361.361 0 0 1-.07.252 34.2 34.2 0 0 0 1.706.76c1.737.773 3.48 1.007 5.238 1.007ZM15.57 26.2c-1.381-1.25-3.055-3.289-1.87-3.97.293-.197.59-.372.893-.524a7.695 7.695 0 0 1-.085-.626c-1.737.169-3.48.506-5.218 1.15-.696.266-1.625 1.87-.233 2.406.813.25 1.588.543 2.337.863.197-.077.282-.191.155-.343-.394-.492-2.168-.69-2.875-1.167.112-.223.595-.337 1.174-.337.505 0 1.09.085 1.573.269l.058.022c-.085.189-.286.358-.324.558-.047.277.622.724 1.244.724.037 0 .074-.003.106-.006.196-.206.393-.415.595-.624.207.05.42.078.627.092.281.131.542.263.744.395.005.065.01.125.005.183a.349.349 0 0 0 .042.183 3.98 3.98 0 0 0-.366-.014c-.425 0-.797.056-1.041.168.77.264 1.615.467 2.46.598Z",
    fill: "url(#f)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 26,
    width: 2,
    height: 1
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.336 26.826c.235-.131.364-.3.344-.495a13.757 13.757 0 0 1-1.11-.131c.243.22.477.417.686.578.026.014.055.031.08.048Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.338 26.825c.238-.131.364-.3.348-.495a13.909 13.909 0 0 1-1.111-.131c.242.22.479.417.684.577a.528.528 0 0 1 .08.05Z",
    fill: "url(#h)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 21,
    width: 56,
    height: 8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.065 28.74c1.568 0 3.13-.157 4.648-.349.635-.037 1.27-.065 1.905-.091 1.908-.075 3.815-.112 5.726-.183.766-.029 1.53-.06 2.3-.098 3.025-.071 6.066-.243 9.115-.563.76-.083 1.524-.172 2.288-.272 6.372-.946 13.105.12 18.445-3.089 1.161-.8-2.554-.8-3.681-1.493a2.222 2.222 0 0 0-.332-.297c-.143.114-.292.229-.449.343-.366.495-1.204.483-1.862.623l-.18.038c-.04.572-.323 1.04-.961 1.318-.535.23-1.107.286-1.693.286-.28 0-.561-.014-.844-.026-.28-.014-.56-.025-.835-.025-.263 0-.524.011-.778.046-1.75.243-3.487.614-5.237.903-.266.043-.532.06-.798.06-.315 0-.63-.025-.947-.063-.037-.005-.077-.008-.117-.014.089.183.129.38.109.595-.032.332-.375.526-.898.638-.481.103-1.11.134-1.782.134-.52 0-1.067-.02-1.585-.037-.52-.02-1.015-.037-1.436-.037-.08 0-.16 0-.234.003-.606.011-1.201.06-1.794.12-.82.083-1.63.186-2.445.249-.509.04-1.021.054-1.533.054-.832 0-1.664-.04-2.491-.089-.455-.028-1.164-.025-1.994-.028-2.179-.003-5.18-.017-6.54-.575l-.127-.026c-1.086-.223-3.252-.043-5.482-.22-2.017-.16-4.085-.618-5.458-1.93-.718-.69-1.247-1.617-1.478-2.858a.914.914 0 0 0-.015-.086c-.3.152-.597.326-.89.524-1.183.68.487 2.72 1.869 3.97.371.06.746.103 1.11.131.02.195-.11.363-.344.495 2.46 1.476 5.1 1.92 7.725 1.92Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.058 28.74c1.569 0 3.127-.158 4.649-.35.633-.037 1.267-.065 1.901-.091 1.912-.075 3.82-.112 5.726-.184.772-.028 1.532-.06 2.304-.097 3.026-.071 6.064-.243 9.112-.563.76-.083 1.526-.172 2.287-.272 6.376-.947 13.106.12 18.447-3.089 1.162-.8-2.552-.8-3.682-1.493a2.227 2.227 0 0 0-.328-.297c-.148.114-.296.228-.449.343-.37.495-1.204.483-1.865.623l-.18.038c-.041.572-.321 1.04-.96 1.318-.534.229-1.105.286-1.691.286-.285 0-.565-.014-.845-.026-.28-.014-.56-.025-.835-.025-.264 0-.523.01-.782.045-1.748.244-3.486.615-5.234.904-.265.043-.534.06-.798.06-.317 0-.629-.026-.946-.063-.037-.005-.079-.008-.116-.014.085.183.127.38.106.595-.032.332-.375.526-.898.638-.481.103-1.11.134-1.78.134-.523 0-1.068-.02-1.585-.037a40.37 40.37 0 0 0-1.437-.037c-.08 0-.159 0-.233.003-.607.011-1.204.06-1.795.12-.82.083-1.628.186-2.446.249-.508.04-1.02.054-1.532.054-.835 0-1.664-.04-2.494-.089-.454-.028-1.162-.025-1.991-.028-2.182-.003-5.177-.018-6.54-.575l-.127-.026c-1.088-.223-3.254-.043-5.483-.22-2.018-.16-4.083-.618-5.457-1.93-.718-.69-1.246-1.617-1.479-2.858 0-.029-.01-.057-.016-.086a8.369 8.369 0 0 0-.887.524c-1.183.68.486 2.72 1.87 3.97.37.06.745.103 1.11.131.015.195-.111.364-.344.495 2.456 1.476 5.098 1.92 7.723 1.92Z",
    fill: "url(#j)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 1,
    width: 27,
    height: 23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m61.974 23.309.18-.038c.658-.14 1.496-.128 1.863-.623.157-.114.306-.229.449-.343.114-.089.226-.178.331-.27.941-.794 1.605-1.641 2.114-3.134a10.718 10.718 0 0 0 .312-1.11h-.003a10.47 10.47 0 0 1-.309 1.11c-.446 1.307-1.01 2.12-1.779 2.837l-.04.009a3.528 3.528 0 0 1-.852.106 2.6 2.6 0 0 1-.747-.103c-1.038-.31-1.35-1.273-1.873-2.283-.192-.369-.378-.517-.564-.517-.228 0-.463.223-.715.52.183.258.366.527.535.798.003 0 .003 0 .003-.003.466.75.855 1.533 1.018 2.237.066.283.095.555.078.807Zm5.49-7.254a12.018 12.018 0 0 0-1.499-6.576c-.673-1.218-1.522-2.293-2.449-3.246a14.061 14.061 0 0 0 .029.032c.003.002.005.005.008.005l.006.009.014.014.015.015.008.008c.009.012.02.02.029.029a.633.633 0 0 0 .008.008.146.146 0 0 0 .029.032c0 .003.003.003.003.005a11.146 11.146 0 0 0 .037.038c.309.329.612.672.898 1.03l.009.008c.005.008.011.017.02.026l.023.031s.002 0 .002.003c1.545 1.948 2.686 4.336 2.82 7.293v.035c.018.4.015.8-.01 1.201ZM41.923 7.71c.267-.64.513-1.273.893-1.848-.38.575-.626 1.204-.892 1.848Zm3.868-4.31c.083-.049.166-.095.246-.14l.06-.038c-.1.06-.203.118-.306.178Zm8.892-1.72c-.132-.028-.266-.054-.398-.08.132.026.264.052.398.08Z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.97 23.308.178-.038c.66-.14 1.499-.128 1.862-.623.158-.114.306-.229.45-.344.117-.088.23-.177.332-.268.94-.795 1.605-1.642 2.117-3.135.194-.575.337-1.17.434-1.773-.036.206-.071.414-.117.62 0 .015-.006.029-.006.043h-.005c-.082.378-.184.747-.306 1.11-.45 1.307-1.013 2.12-1.78 2.837l-.04.01a3.545 3.545 0 0 1-.854.105 2.61 2.61 0 0 1-.747-.103c-1.038-.31-1.35-1.273-1.871-2.283-.194-.368-.379-.517-.568-.517-.225 0-.46.223-.71.52.178.258.363.526.531.798.005 0 .005 0 .005-.003.466.75.854 1.533 1.018 2.237.066.283.092.555.076.807Zm5.49-7.254a11.97 11.97 0 0 0-1.503-6.576c-.67-1.218-1.518-2.293-2.443-3.246a14.238 14.238 0 0 0 0 .003c.01.009.015.017.025.028.005.004.005.007.01.007 0 .002 0 .005.005.008l.016.014c.005.006.005.009.015.014 0 .003.005.006.005.01.01.01.02.02.031.028 0 .003.005.005.01.008a.097.097 0 0 0 .026.032c0 .003.005.003.005.005l.03.035s0 .003.006.003c.306.329.613.672.9 1.03 0 .002.005.005.005.008.005.009.015.017.02.026.01.01.015.02.026.031v.003c1.544 1.948 2.684 4.336 2.822 7.293v.035c.015.4.015.8-.01 1.201ZM41.923 7.708c.266-.64.511-1.273.89-1.847-.379.574-.624 1.204-.89 1.847Zm3.865-4.31c.082-.049.164-.094.246-.14l.061-.038-.307.178Z",
    fill: "url(#l)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 13,
    width: 24,
    height: 9
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.248 21.86c.288 0 .577-.037.852-.105l.04-.01c.77-.717 1.333-1.53 1.779-2.836a10.447 10.447 0 0 0 .157-.51c-.2.306-.48.524-.932.627a1.64 1.64 0 0 1-.366.037c-.624 0-1.416-.266-1.83-.63-1.022-.889-.807-3.002-2.06-3.738a1.053 1.053 0 0 0-.546-.157c-.718 0-1.365.744-2.174.944-.18.046-.358.063-.53.063-.394 0-.768-.097-1.143-.194-.372-.1-.744-.198-1.133-.198a2.25 2.25 0 0 0-.386.034 7.71 7.71 0 0 0-.592.144c.995.354 1.993.95 3.015 1.856.288.26.88.892 1.498 1.687.149.192.3.395.452.604.252-.298.487-.52.715-.52.186 0 .372.148.564.517.523 1.01.835 1.973 1.873 2.282a2.6 2.6 0 0 0 .747.103Zm-18.245-3.543c.106-.18.214-.358.323-.535.057-.092.117-.18.177-.266-.231-.527-.657-1.044-1.138-1.479.109.289.209.58.3.884.132.446.246.912.338 1.396Zm.766-1.153c.049-.063.1-.123.152-.183a1.004 1.004 0 0 0-.232-.235c.029.146.057.284.08.418Zm.452-.51c.14-.145.283-.288.43-.431l.02-.02c-.167-.812-.307-1.636-.587-2.426-.057-.163-.115-.326-.175-.486-.574.049-1.15.183-1.724.318-.306.068-.612.14-.918.2l.083.137v-.006c.251.427.483.864.689 1.319.79.3 1.539.86 2.182 1.396Zm1.236-.869.243-.091a4.22 4.22 0 0 0 .249-.106 20.293 20.293 0 0 0-.135-2.036 3.61 3.61 0 0 0-1.279-.278c.367.807.659 1.656.922 2.511Zm1.144-.463c-.023-.44-.009-.89.031-1.339a3.972 3.972 0 0 0-.146-.088c.046.475.083.952.115 1.427Zm.844-.143c.002 0 .005-.003.005-.003.052-.18.103-.357.16-.526-.017-.012-.034-.026-.054-.037l-.111.566Z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 67.636 7.332)",
    fill: "url(#n)",
    d: "M0 0h23.602v14.736H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 14,
    width: 1,
    height: 4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.231 17.753c.046-.206.083-.415.118-.62v-.003c.002-.018.005-.035.005-.052.003-.003.003-.009.003-.011l.006-.035c0-.011.003-.023.006-.031v-.02c.04-.272.068-.547.088-.824 0-.006.003-.014.003-.023v-.026a.187.187 0 0 0 .003-.04v-.008a11.459 11.459 0 0 1-.232 1.693Z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 67.773 14.623)",
    fill: "url(#p)",
    d: "M0 0h.721v3.438H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 5,
    width: 2,
    height: 4
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.326 8.996c.08-.149.163-.3.24-.463-.077.16-.16.314-.24.463Zm1.499-3.135c.02-.028.04-.06.063-.088 0-.003.003-.003.003-.006-.023.031-.043.063-.066.094Z",
    fill: "#fff"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 43.044 5.614)",
    fill: "url(#r)",
    d: "M0 0h1.865v3.581H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 5,
    width: 28,
    height: 15
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M65.77 19.054c.132 0 .255-.012.367-.037.451-.103.732-.32.932-.627.057-.197.109-.397.152-.6h.002l.009-.043c.206-.95.283-1.931.243-2.895v-.034c-.134-2.958-1.275-5.346-2.82-7.294l.06.075.026.034.003.003c1.03 1.324 1.87 2.849 2.34 4.613a1.384 1.384 0 0 1-1.158.563c-1.423 0-3.296-1.635-4.157-2.173-.712-.45-1.613-1.061-2.482-1.061a1.62 1.62 0 0 0-.761.183c-.695.363-1.25 1.261-1.83 1.845-.667.669-1.242.924-1.78.924a1.96 1.96 0 0 1-.715-.146c-.274.14-.529.32-.76.517a6.692 6.692 0 0 0-1.665 2.04c.346-.037.69-.058 1.03-.058.26 0 .52.012.78.038.026-.003.055-.003.083-.003.152 0 .31.011.47.031.09.012.305.072.566.166.226.057.449.123.672.206.194-.054.389-.103.592-.143a2.26 2.26 0 0 1 .386-.034c.389 0 .76.097 1.133.197.374.097.749.195 1.144.195.171 0 .349-.018.529-.063.81-.2 1.456-.944 2.173-.944.178 0 .358.046.547.157 1.252.735 1.038 2.849 2.059 3.738.415.364 1.207.63 1.83.63ZM50.603 14.64c.166-.483.383-.912.792-1.292.372-.347.733-.601 1.165-.859a3.422 3.422 0 0 1 1.035-.417c-.65-.406-1.307-1.01-2.082-1.476-.106-.063-.212-.126-.318-.183-.04 1.373-.374 2.869-.646 4.19.02.012.037.026.054.037Zm-.978-.666c.112-1.313.42-2.651.506-3.93l.009-.129a9.675 9.675 0 0 0-1.45-.443c.409 1.436.643 2.923.79 4.413l.145.089Zm-5.366-.175c.306-.06.612-.131.919-.2.574-.134 1.15-.269 1.724-.317a17.928 17.928 0 0 0-.812-1.908c-.132-.26-.775-.895-.652-1.147.535.386.938 1.027 1.293 1.573.306.466.566.955.798 1.465a3.61 3.61 0 0 1 1.278.277c-.1-.86-.24-1.719-.389-2.56a21.517 21.517 0 0 0-.36-1.639c-1.041-.183-2.102-.257-3.24-.4-.673-.086-2.011-.41-2.149-1.459-.034-.269.109-1.061.2-1.699.003-.006.009-.008.012-.014-.023.029-.043.06-.063.089-.38.574-.626 1.207-.892 1.847-.115.275-.232.55-.367.824-.077.163-.16.315-.24.463a9.744 9.744 0 0 1-.389.641c.135.146.266.292.398.435.246.263.483.523.712.786a21.617 21.617 0 0 1 1.968 2.54l.197.31c0 .002 0 .002-.003.002.02.029.04.06.057.091Z",
    fill: "#fff"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 67.773 5.617)",
    fill: "url(#t)",
    d: "M0 0h27.034v13.592H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 3,
    width: 3,
    height: 2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.59 4.97c.482-.466 1.026-.844 1.575-1.184-.55.34-1.093.718-1.579 1.184h.003Z",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 45.32 3.63)",
    fill: "url(#v)",
    d: "M0 0h2.008v1.579H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "w",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 4,
    width: 2,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.883 5.778a5.819 5.819 0 0 1 .706-.815h-.002a6.146 6.146 0 0 0-.532.587c-.02.022-.04.048-.06.071-.037.051-.074.1-.109.152 0 .002-.003.002-.003.005Z",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 43.747 4.768)",
    fill: "url(#x)",
    d: "M0 0h1.15v1.293H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "y",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 3,
    width: 26,
    height: 10
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.941 12.815a1.384 1.384 0 0 0 1.159-.564c-.47-1.765-1.31-3.29-2.34-4.614.246.318.483.647.704.987-.816-.277-1.745-.967-2.317-1.244-1.482-.718-2.943-2.13-4.588-2.285a1.276 1.276 0 0 0-.143-.009c-.452 0-.646.226-.832.45-.186.225-.363.451-.784.451-.066 0-.134-.006-.211-.017-1.339-.2-2.517-1.116-3.899-1.187-.06-.003-.12-.003-.18-.003-.91 0-1.819.346-2.731.695-.796.3-1.593.604-2.403.678.35.707.69 1.424.964 2.182.134.375.257.755.366 1.139.483.108.967.251 1.45.443.1-1.301.398-2.646.426-3.927.155 1.121.472 2.237.595 3.378.038.337.046.686.035 1.047.105.057.211.12.317.183.775.466 1.433 1.07 2.082 1.476.295-.063.595-.089.918-.089.255 0 .52.014.813.037-.198.132-.452.117-.692.189a2.847 2.847 0 0 0-.432.174c.234.092.471.146.715.146.537 0 1.112-.254 1.779-.924.58-.583 1.135-1.481 1.83-1.844a1.62 1.62 0 0 1 .76-.183c.87 0 1.771.612 2.483 1.06.861.538 2.735 2.175 4.156 2.175Zm-17.867-3.47a26.19 26.19 0 0 0-.941-2.877c-.04-.1-.077-.198-.114-.298h-.012a3.46 3.46 0 0 1-.683-.066c-1.342-.268-1.35-1.467-.813-2.53-.111.065-.22.13-.332.2-.549.34-1.092.717-1.575 1.183a5.807 5.807 0 0 0-.707.816c-.003.005-.008.008-.011.014-.092.638-.235 1.43-.2 1.699.137 1.05 1.475 1.373 2.148 1.459 1.138.143 2.199.217 3.24.4Z",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 67.35 3.334)",
    fill: "url(#z)",
    d: "M0 0h24.889v9.73H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "A",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m63.607 6.315-.008-.008c0 .002.002.002.002.002s.003.003.003.006h.003Z",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.92 6.04)",
    fill: "url(#B)",
    d: "M0 0h.578v.578H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "C",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m63.56 6.294-.006-.008c0 .003.003.005.006.008Z",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.77 6.057)",
    fill: "url(#D)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "E",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 7,
    width: 1,
    height: 1
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.634 7.491a.145.145 0 0 1-.02-.024l.02.024Z",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 64.91 7.188)",
    fill: "url(#F)",
    d: "M0 0h.578v.578H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "G",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 2,
    height: 2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.612 7.47c-.286-.358-.589-.701-.898-1.03l.009.009a.424.424 0 0 0 .043.046c.003.005.005.008.008.01.009.007.014.015.02.02l.012.012.034.037c.003.003.006.006.006.01l.023.022.002.003a.704.704 0 0 0 .046.048v.003c.009.006.015.015.023.023l.006.009c.011.011.026.026.037.04l.009.008c.005.009.014.015.02.023l.005.006.035.04.011.011.017.02.012.015c.011.008.02.02.028.028l.015.018c.005.008.011.014.017.02l.014.017a.183.183 0 0 1 .023.025c.006.006.011.015.017.02a.035.035 0 0 0 .014.015c.006.008.015.017.02.026.006.005.012.011.015.017.008.008.014.017.023.023.002.005.008.011.011.017.009.008.017.02.026.028l.008.009.026.031c.003.003.006.006.006.009l.063.074c.003.003.005.006.005.009l.066.077s0 .003.003.003l.12.149Z",
    fill: "#fff"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 64.776 6.201)",
    fill: "url(#H)",
    d: "M0 0h1.293v1.436H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "I",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 6,
    width: 1,
    height: 2
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m64.716 7.603-.06-.075c0-.003-.003-.003-.003-.003l-.023-.031-.02-.026-.009-.008-.12-.15c.078.095.158.192.235.293Zm-.664-.793-.011-.011c.005.003.008.008.011.011Z",
    fill: "#fff"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 64.91 6.19)",
    fill: "url(#J)",
    d: "M0 0h1.436v1.579H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "K",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m63.713 6.427-.033-.033a.072.072 0 0 1 .024.024l.009.009Z",
    fill: "#fff"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.92 6.19)",
    fill: "url(#L)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "M",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.673 6.396c-.011-.009-.02-.02-.027-.03 0 .002 0 .002.002.002a.632.632 0 0 0 .024.027Z",
    fill: "#fff"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#M)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.919 6.202)",
    fill: "url(#N)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "O",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.635 6.348c-.008-.008-.02-.017-.027-.027 0 .002.002.002.002.002l.02.022c.002 0 .002.003.005.003Z",
    fill: "#fff"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#O)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.917 6.046)",
    fill: "url(#P)",
    d: "M0 0h.578v.578H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Q",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m63.597 6.316-.014-.013.011.01.003.003Z",
    fill: "#fff"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Q)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.774 6.055)",
    fill: "url(#R)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "S",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m63.597 6.316-.011-.01-.014-.014.025.024Z",
    fill: "#fff"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#S)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.776 6.05)",
    fill: "url(#T)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "U",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.559 6.274c-.003 0-.006-.002-.008-.005.002 0 .002.003.002.003l.006.002Z",
    fill: "#fff"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#U)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.773 6.045)",
    fill: "url(#V)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "W",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.554 6.274s0-.002-.003-.002a.129.129 0 0 0 .003.002Z",
    fill: "#fff"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#W)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.773 6.045)",
    fill: "url(#X)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Y",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 3,
    width: 2,
    height: 1
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 3.574c.183-.108.363-.211.543-.314-.08.045-.163.091-.246.14-.097.057-.197.114-.297.174Z",
    fill: "#fff"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Y)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 46.32 3.04)",
    fill: "url(#Z)",
    d: "M0 0h1.007v.721H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aa",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 7,
    width: 1,
    height: 1
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.491 7.314c-.005 0-.005-.005-.005-.005l.005.005Z",
    fill: "#fff"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aa)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 64.776 7.046)",
    fill: "url(#ab)",
    d: "M0 0h.578v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ac",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 6,
    width: 1,
    height: 1
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.215 6.995a.032.032 0 0 1-.014-.013c.003.005.009.008.014.013Z",
    fill: "#fff"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ac)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 64.49 6.77)",
    fill: "url(#ad)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ae",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M63.934 6.684c-.008-.009-.014-.017-.022-.022l.022.022Z",
    fill: "#fff"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 64.198 6.48)",
    fill: "url(#af)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ag",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M63.916 6.646Z",
    fill: "#fff"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ag)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 64.067 6.324)",
    fill: "url(#ah)",
    d: "M0 0h.435v.578H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ai",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m63.717 6.437-.009-.009c-.002 0-.002-.003-.002-.003l-.009-.008.02.02Z",
    fill: "#fff"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ai)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.915 6.191)",
    fill: "url(#aj)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ak",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M63.678 6.404a.037.037 0 0 0-.011-.008c0-.003-.003-.003-.003-.005l-.008-.008c.008.008.014.016.022.021Z",
    fill: "#fff"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.913 6.192)",
    fill: "url(#al)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "am",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.639 6.357c-.003 0-.003 0-.003-.002l-.009-.009c-.002 0-.002-.003-.005-.003.005.006.011.009.017.014Z",
    fill: "#fff"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#am)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.913 6.191)",
    fill: "url(#an)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ao",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M63.613 6.326s-.003 0-.003-.003h-.003c.003 0 .003.003.006.003Z",
    fill: "#fff"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.778 6.05)",
    fill: "url(#ap)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aq",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.597 6.316s-.003 0-.003-.003l-.004-.003c0 .003.003.003.007.006Z",
    fill: "#fff"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.774 6.044)",
    fill: "url(#ar)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "as",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 6,
    width: 1,
    height: 1
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M63.56 6.294c-.003-.003-.006-.005-.006-.008-.002 0-.002 0-.005-.003.005.003.008.008.01.01Z",
    fill: "#fff"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 63.77 6.057)",
    fill: "url(#at)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "au",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 1,
    width: 7,
    height: 2
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48.666 2.05a11.367 11.367 0 0 1 3.676-.627 10.816 10.816 0 0 0 0-.003c-1.239 0-2.463.218-3.676.63Z",
    fill: "#fff"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#au)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 59.193 1.177)",
    fill: "url(#av)",
    d: "M0 0h10.731v2.151H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aw",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 1,
    width: 21,
    height: 8
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M65.453 8.636c-.22-.34-.457-.67-.704-.987l-.002-.003a7.658 7.658 0 0 0-.026-.034c-.077-.1-.157-.198-.235-.292l-.002-.003-.066-.077c0-.003-.003-.006-.006-.009l-.063-.074c0-.003-.003-.006-.006-.009l-.025-.031-.009-.009c-.008-.008-.017-.02-.026-.028-.002-.006-.008-.012-.011-.017-.009-.006-.014-.015-.023-.023-.003-.006-.009-.012-.014-.017l-.02-.026c-.006-.006-.012-.009-.015-.014-.005-.006-.011-.015-.017-.02-.006-.01-.014-.018-.023-.026a.077.077 0 0 1-.014-.017.124.124 0 0 1-.017-.02c-.006-.006-.009-.012-.014-.018-.009-.008-.018-.02-.029-.028-.003-.006-.006-.009-.011-.014-.006-.006-.012-.015-.018-.02-.002-.003-.005-.01-.011-.012l-.034-.04-.006-.006c-.006-.008-.014-.014-.02-.023l-.009-.008c-.011-.014-.025-.029-.037-.04l-.006-.009-.023-.023v-.003c-.017-.014-.03-.031-.045-.048l-.003-.003-.023-.023c0-.003-.003-.006-.006-.008l-.034-.038-.011-.011c-.006-.006-.012-.014-.02-.02a.04.04 0 0 1-.01-.012c-.01-.011-.022-.022-.033-.037l-.009-.008a8.701 8.701 0 0 0-.034-.038c-.009-.005-.015-.014-.023-.022a.13.13 0 0 1-.017-.02c-.006-.006-.012-.009-.017-.015-.006-.008-.015-.014-.02-.023l-.006-.002c0-.003-.003-.006-.003-.006-.003-.003-.006-.003-.006-.006l-.026-.026c-.002-.002-.005-.008-.011-.011a14.077 14.077 0 0 0-2.546-2.068 16.551 16.551 0 0 0-1.976-1.075 19.047 19.047 0 0 0-1.753-.71 22.42 22.42 0 0 0-2.589-.735l-.397-.08a10.788 10.788 0 0 0-1.954-.177c-1.238 0-2.462.214-3.675.626-.86.292-1.713.687-2.56 1.173-.02.011-.04.026-.06.037-.18.103-.36.206-.543.315-.538 1.064-.53 2.262.812 2.53.229.047.455.067.684.067h.011c-.243-.632-.469-1.267-.583-1.931.3.646.626 1.276.94 1.914.81-.075 1.608-.378 2.403-.678.913-.35 1.822-.695 2.732-.695.06 0 .12 0 .18.002 1.381.072 2.56.987 3.898 1.187.077.012.146.018.212.018.42 0 .598-.226.784-.452.185-.223.38-.45.832-.45.046 0 .091.004.143.01 1.644.154 3.106 1.567 4.587 2.285.572.277 1.502.966 2.317 1.244Z",
    fill: "#fff"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 65.639 1.194)",
    fill: "url(#ax)",
    d: "M0 0h20.885v7.728H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ay",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 4,
    width: 11,
    height: 14
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 17.517a5.61 5.61 0 0 1 .266-.352c-.023-.135-.052-.272-.08-.418.089.063.166.143.231.235.038-.04.075-.08.11-.123h.002c.06-.069.126-.138.189-.203-.644-.535-1.393-1.096-2.183-1.396.118.254.226.515.327.778.48.435.906.952 1.138 1.479Zm1.167-1.313c.223-.206.475-.303.786-.418-.263-.855-.555-1.704-.92-2.511-.232-.51-.493-.998-.799-1.465-.354-.546-.758-1.187-1.292-1.573-.123.252.52.887.652 1.147.314.627.575 1.259.812 1.908.06.16.117.323.175.486.28.79.42 1.614.586 2.426Zm1.278-.615.078-.034c.48-.146.952-.272 1.418-.375l.112-.566c.271-1.322.606-2.818.646-4.19.012-.361.003-.71-.034-1.048-.123-1.14-.44-2.256-.595-3.377-.029 1.28-.326 2.625-.426 3.927l-.009.128c-.086 1.279-.395 2.617-.506 3.93-.04.45-.054.898-.032 1.339a48.279 48.279 0 0 0-.114-1.427c-.146-1.49-.38-2.978-.79-4.414a17.598 17.598 0 0 0-.365-1.138c-.275-.758-.615-1.476-.964-2.182-.315-.638-.641-1.268-.941-1.914.114.664.34 1.299.583 1.93.037.1.075.198.114.298.367.941.687 1.902.942 2.878.14.543.263 1.086.36 1.639.149.84.289 1.698.389 2.56.077.677.126 1.358.134 2.036Zm1.502-.412.189-.04s-.003 0-.003-.003c.386-.08.77-.14 1.147-.183a6.69 6.69 0 0 1 1.664-2.04 3.96 3.96 0 0 1 .761-.517c.137-.069.283-.129.432-.175.24-.071.495-.057.692-.188a10.398 10.398 0 0 0-.812-.038 4.35 4.35 0 0 0-.918.09 3.422 3.422 0 0 0-1.036.417 6.532 6.532 0 0 0-1.164.858c-.409.38-.626.81-.792 1.293-.057.168-.109.346-.16.526Zm4.261-.051a3.41 3.41 0 0 0-.566-.166 3.783 3.783 0 0 0-.469-.032c-.029 0-.057 0-.083.003.372.034.747.097 1.118.195Z",
    fill: "#fff"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ay)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5 17.517c.087-.123.173-.24.265-.352-.02-.135-.051-.272-.082-.418a.966.966 0 0 1 .234.235c.036-.04.076-.08.107-.123h.005c.061-.069.127-.138.188-.203-.646-.535-1.394-1.096-2.182-1.396.117.255.224.515.325.778.484.435.906.953 1.14 1.479Zm1.165-1.313c.224-.206.478-.303.789-.418-.265-.855-.555-1.704-.921-2.511-.234-.51-.494-.998-.799-1.464-.356-.547-.758-1.187-1.292-1.573-.122.251.519.886.651 1.146.315.627.575 1.259.814 1.908.056.16.117.323.173.487.28.789.422 1.612.585 2.425Zm1.277-.615c.03-.011.056-.023.081-.034.479-.146.952-.272 1.415-.375.04-.186.076-.375.112-.566.275-1.322.61-2.818.646-4.19.015-.361.005-.71-.03-1.047-.123-1.142-.443-2.257-.596-3.378-.03 1.28-.325 2.625-.427 3.927-.005.043-.005.086-.01.128-.087 1.279-.392 2.617-.504 3.93-.04.45-.056.898-.03 1.339-.036-.475-.072-.953-.118-1.427-.142-1.49-.381-2.978-.788-4.414a17.718 17.718 0 0 0-.366-1.138c-.275-.758-.616-1.476-.962-2.182-.316-.638-.641-1.267-.941-1.914.112.664.34 1.298.58 1.93.04.101.076.198.117.298.366.941.687 1.902.94 2.878.138.543.26 1.087.362 1.639.148.84.285 1.698.387 2.56.076.677.127 1.358.132 2.036Zm1.506-.412.188-.04s-.005 0-.005-.003c.387-.08.768-.14 1.15-.183.422-.778.9-1.399 1.664-2.04.229-.197.483-.377.758-.517.137-.069.285-.129.432-.174.24-.072.494-.058.692-.19-.29-.022-.554-.036-.809-.036-.325 0-.626.025-.92.088-.341.075-.677.206-1.033.418a6.51 6.51 0 0 0-1.166.858c-.412.38-.625.81-.793 1.293a12.22 12.22 0 0 0-.158.526Zm4.258-.052a3.438 3.438 0 0 0-.564-.165 3.829 3.829 0 0 0-.468-.032c-.03 0-.056 0-.087.003a6.89 6.89 0 0 1 1.12.194Z",
    fill: "url(#az)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aA",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 15,
    width: 14,
    height: 11
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M50.831 25.878c.266 0 .532-.017.798-.06 1.75-.289 3.487-.66 5.237-.904.255-.034.515-.046.778-.046.275 0 .555.012.835.026.283.012.563.026.844.026.586 0 1.158-.057 1.693-.286.638-.278.921-.747.961-1.319a2.76 2.76 0 0 0-.077-.806c.091.391.111.758.037 1.08-.003.004-.003.007-.003.01v.002a1.374 1.374 0 0 1-.392.69s0 .002-.003.002l-.008.009-.003.003-.009.008c-.002.003-.005.003-.005.006-.003 0-.003.003-.006.003-.003.003-.003.006-.006.006 0 .003-.003.003-.003.003a1.772 1.772 0 0 1-.454.288h-.006l-.009.006c-.005.003-.011.003-.017.006-.529.232-1.104.289-1.687.289-.28 0-.567-.015-.85-.029-.283-.011-.566-.026-.843-.026-.26 0-.515.012-.767.046-1.753.246-3.486.615-5.234.904-.272.043-.54.063-.81.063a7.989 7.989 0 0 1 .01 0Zm-.192-3.867c.412 0 .841-.117 1.044-.149.781-.12 1.373-1.04 2.097-1.158a.594.594 0 0 1 .1-.009c.269 0 .503.186.738.37.234.185.472.371.743.371h.018c.6-.017.912-.972 1.478-1.227a.987.987 0 0 1 .384-.083c.514 0 .93.466 1.467.807.277.177.5.257.712.257.28 0 .538-.143.87-.403.206-.16.4-.34.589-.512a15.508 15.508 0 0 0-.987-1.402c.069.089.137.178.206.272a.709.709 0 0 1-.215.029c-.603 0-1.601-.558-1.833-.621-.274-.077-.583-.192-.872-.192a.79.79 0 0 0-.386.089c-.395.215-.238.48-.495.82-.203.261-.452.33-.721.33-.157 0-.32-.023-.483-.046a3.114 3.114 0 0 0-.478-.049.998.998 0 0 0-.246.026c-.449.1-.978.492-1.479.492a.823.823 0 0 1-.429-.117c-.918-.552.163-.921.572-1.15.515-.28 1.233-.592.721-1.676-.252-.532-.6-.604-.955-.604-.066 0-.132.003-.197.006-.066.003-.132.006-.198.006a1.2 1.2 0 0 1-.289-.029c-.437-.094-1.19-.557-1.481-1.324l-.189.04s-.003.003-.006.003c-.466.103-.938.229-1.418.375l-.078.034c-.085.04-.168.074-.248.106.105-.043.214-.086.328-.14.306-.092.604-.178.904-.25-.083.05-.169.095-.251.144-.724 2.076.763 2.062 1.564 2.534-.092 1.213-1.916 2.483-1.513 3.535.149.39.52.495.912.495Z",
    fill: "#fff"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aA)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.833 25.878c.263 0 .532-.017.795-.06 1.752-.29 3.49-.661 5.237-.905.254-.034.517-.045.78-.045.274 0 .552.012.836.026.284.011.562.026.841.026.588 0 1.16-.058 1.697-.287.633-.277.917-.746.957-1.318.02-.252-.01-.523-.076-.807.091.392.112.758.036 1.081v.012a1.365 1.365 0 0 1-.395.689v.003c-.005.003-.005.006-.01.009v.003c-.006.002-.01.005-.01.008-.006.003-.006.003-.006.006-.005 0-.005.003-.005.003-.005.002-.005.005-.005.005 0 .003-.005.003-.005.003a1.728 1.728 0 0 1-.456.29h-.005l-.01.005-.015.006c-.527.231-1.104.289-1.687.289-.283 0-.567-.015-.85-.03-.284-.01-.568-.025-.842-.025-.263 0-.516.012-.77.046-1.752.246-3.485.615-5.232.904a5.181 5.181 0 0 1-.81.063 7.937 7.937 0 0 1 .01 0Zm-.193-3.867c.41 0 .841-.117 1.044-.149.78-.12 1.372-1.041 2.097-1.158a.567.567 0 0 1 .101-.009c.268 0 .501.186.734.369.239.186.477.372.745.372h.02c.598-.018.912-.973 1.48-1.227a.964.964 0 0 1 .38-.083c.516 0 .931.466 1.468.806.279.177.502.258.71.258.283 0 .541-.143.87-.404.208-.16.4-.34.588-.511a14.948 14.948 0 0 0-.983-1.402c.066.089.137.177.203.271a.674.674 0 0 1-.213.03c-.602 0-1.6-.558-1.833-.622-.274-.077-.583-.191-.872-.191a.77.77 0 0 0-.385.089c-.395.214-.238.48-.496.82-.203.261-.45.33-.72.33-.156 0-.323-.023-.486-.046a3.102 3.102 0 0 0-.476-.049c-.086 0-.167.006-.248.026-.446.1-.977.492-1.479.492a.813.813 0 0 1-.425-.118c-.922-.551.162-.92.572-1.15.512-.28 1.23-.592.72-1.676-.254-.532-.603-.603-.958-.603-.066 0-.132.003-.198.006-.065.003-.131.006-.197.006-.096 0-.198-.006-.289-.03-.435-.093-1.19-.557-1.479-1.323-.066.014-.127.026-.187.04l-.01.002c-.466.104-.938.23-1.419.375l-.076.035c-.086.04-.167.074-.248.106.106-.044.213-.087.33-.14.303-.093.602-.178.901-.25-.081.05-.167.095-.248.143-.724 2.077.76 2.062 1.565 2.534-.096 1.213-1.92 2.483-1.515 3.536.147.389.522.495.912.495Z",
    fill: "url(#aB)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aC",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 15,
    width: 5,
    height: 4
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M59.893 18.874c-.618-.795-1.21-1.427-1.5-1.688-1.02-.906-2.018-1.501-3.014-1.856.993.355 1.99.953 3.012 1.86.292.26.88.889 1.502 1.684Z",
    fill: "#fff"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aC)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 60.047 15.066)",
    fill: "url(#aD)",
    d: "M0 0h4.868v4.01H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aE",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 14,
    width: 5,
    height: 2
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M55.386 15.323a6.476 6.476 0 0 0-.672-.206c.005 0 .011.003.017.006.217.054.434.12.655.2Zm-3.601-.377c.346-.04.69-.06 1.032-.06.255 0 .51.011.764.037h.014a7.94 7.94 0 0 0-.78-.037c-.34 0-.684.02-1.03.057v.003Z",
    fill: "#fff"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aE)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 55.624 14.63)",
    fill: "url(#aF)",
    d: "M0 0h4.01v.864H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aG",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 14,
    width: 5,
    height: 2
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.638 15.134c.383-.08.763-.143 1.144-.183v-.003c-.378.043-.761.103-1.147.183 0 .003.003.003.003.003Zm4.09-.006a6.943 6.943 0 0 0-1.136-.2h-.014c.383.034.766.1 1.15.2Z",
    fill: "#fff"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aG)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 54.905 14.773)",
    fill: "url(#aH)",
    d: "M0 0h4.439v.578H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aI",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 14,
    width: 11,
    height: 7
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M52.898 20.02c.5 0 1.03-.392 1.479-.492a1 1 0 0 1 .246-.026c.154 0 .314.023.477.049.163.022.326.045.484.045.268 0 .517-.068.72-.329.258-.34.1-.606.495-.82a.79.79 0 0 1 .386-.09c.29 0 .598.115.873.192.231.063 1.23.621 1.833.621a.71.71 0 0 0 .215-.029c-.07-.094-.138-.183-.206-.271-.621-.795-1.21-1.425-1.502-1.685-1.021-.907-2.02-1.504-3.012-1.86a6.591 6.591 0 0 0-.655-.2 7.018 7.018 0 0 0-1.15-.2 7.596 7.596 0 0 0-.763-.037c-.343 0-.687.02-1.033.06-.38.04-.76.103-1.144.183.292.767 1.044 1.23 1.482 1.325.091.023.189.028.289.028.066 0 .131-.003.197-.005.066-.003.132-.006.197-.006.355 0 .704.071.956.603.512 1.084-.206 1.396-.721 1.677-.41.228-1.49.597-.572 1.15.14.082.283.117.429.117Z",
    fill: "#fff"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aI)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 60.346 14.63)",
    fill: "url(#aJ)",
    d: "M0 0h9.873v5.583H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aK",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 16,
    width: 1,
    height: 1
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M47.227 16.652c.14-.146.284-.286.43-.429.005-.008.014-.014.02-.023l-.02.02c-.146.143-.29.287-.43.432Z",
    fill: "#fff"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aK)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 48.907 15.486)",
    fill: "url(#aL)",
    d: "M0 0h1.865v1.436H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aM",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 15,
    width: 2,
    height: 2
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.042 16.861c.063-.071.126-.14.19-.206-.064.066-.13.135-.19.203v.003Zm.638-.658c.223-.205.478-.303.787-.417-.312.114-.564.212-.787.417Z",
    fill: "#fff"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aM)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 48.618 15.636)",
    fill: "url(#aN)",
    d: "M0 0h1.865v1.436H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aO",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 20,
    width: 2,
    height: 3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M61.902 22.51c-.163-.703-.552-1.487-1.018-2.236 0 .003 0 .003-.003.003.47.746.858 1.53 1.021 2.234Z",
    fill: "#fff"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aO)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 62.058 20.068)",
    fill: "url(#aP)",
    d: "M0 0h1.436v2.723H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aQ",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 15,
    width: 16,
    height: 10
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M61.502 24.328c.003 0 .003-.003.006-.006l-.006.006Zm.012-.009c0-.003.002-.003.005-.006l-.005.006Zm.423-.73c.074-.323.054-.689-.037-1.08-.163-.704-.552-1.488-1.021-2.234-.19.171-.383.351-.59.512-.331.26-.589.403-.869.403-.212 0-.435-.08-.712-.258-.538-.34-.953-.806-1.467-.806a.987.987 0 0 0-.384.083c-.566.254-.878 1.21-1.478 1.227h-.017c-.272 0-.51-.186-.744-.372-.235-.183-.47-.369-.738-.369a.583.583 0 0 0-.1.009c-.724.117-1.316 1.038-2.097 1.158-.203.032-.632.149-1.044.149-.391 0-.763-.106-.912-.495-.403-1.053 1.422-2.322 1.513-3.535-.8-.472-2.288-.458-1.564-2.534.082-.049.168-.095.251-.143-.3.071-.597.157-.904.248-.114.055-.223.098-.329.14l-.243.092c-.309.114-.563.212-.786.418-.006.008-.014.014-.02.023-.146.143-.289.283-.43.429a6.753 6.753 0 0 0-.188.206c.492.574.921 1.24 1.056 2.116.24 1.628-.924 1.118-1.167 2.13-.27 1.13 1.976 1.831 2.508 2.029.495.183.96.266 1.421.266.675 0 1.333-.177 2.02-.47.18-.076.351-.105.517-.105.298 0 .58.094.87.189.291.094.592.191.92.191.444-.003.83-.117 1.125-.66.117-.215.186-.807.3-.956a.493.493 0 0 1 .41-.211c.617 0 1.466.98 1.964 1.23.338.168.984.414 1.542.414.363 0 .686-.103.87-.397.18-.292.25-.615.24-.944.294.698.437 1.364.314 1.908Z",
    fill: "#fff"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 62.339 15.063)",
    fill: "url(#aR)",
    d: "M0 0h15.879v9.73H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aS",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 16,
    width: 1,
    height: 2
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M46.32 17.787c.06-.091.117-.18.178-.266-.06.086-.12.175-.178.266Zm.444-.615c.051-.063.1-.126.154-.183l-.003-.003a4.61 4.61 0 0 0-.151.183v.003Z",
    fill: "#fff"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aS)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 47.178 16.786)",
    fill: "url(#aT)",
    d: "M0 0h1.007v1.293H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aU",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 16,
    width: 2,
    height: 2
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.505 17.517c.086-.123.174-.238.266-.35v-.002c-.092.111-.18.229-.266.352Zm.42-.532c.035-.043.072-.083.11-.126h-.004c-.034.043-.071.083-.108.123l.002.003Z",
    fill: "#fff"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aU)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 47.19 16.638)",
    fill: "url(#aV)",
    d: "M0 0h.864v1.15H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aW",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 23,
    width: 1,
    height: 2
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M61.547 24.29Z",
    fill: "#fff"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aW)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 62.2 23.357)",
    fill: "url(#aX)",
    d: "M0 0h12.59v2.723H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aY",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 16,
    width: 2,
    height: 3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M45.997 18.315a16.877 16.877 0 0 1 .5-.8v-.003c-.06.085-.117.174-.177.266-.108.177-.217.354-.323.535v.002Zm.767-1.152c.051-.063.102-.123.154-.183-.054.057-.103.12-.154.183Z",
    fill: "#fff"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aY)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 47.178 16.774)",
    fill: "url(#aZ)",
    d: "M0 0h1.436v1.722H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ba",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 16,
    width: 2,
    height: 2
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M46.505 17.527a7.103 7.103 0 0 1 0-.003v.003Zm.42-.535c.035-.042.072-.082.11-.123v-.002c-.038.043-.075.083-.11.125Z",
    fill: "#fff"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 47.19 16.645)",
    fill: "url(#bb)",
    d: "M0 0h.864v1.15H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bc",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 16,
    width: 17,
    height: 10
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M50.824 25.878c.269 0 .538-.02.81-.063 1.747-.289 3.48-.658 5.233-.904.252-.034.507-.046.767-.046.277 0 .56.015.843.026.284.015.57.029.85.029.583 0 1.158-.057 1.688-.29l.017-.005.008-.006h.006c.18-.082.332-.177.455-.288 0 0 .003 0 .003-.003l.005-.006c.003 0 .003-.003.006-.003l.006-.006.008-.008.003-.003.009-.009c.003 0 .003-.002.003-.002.203-.192.329-.427.391-.69v-.003c0-.002 0-.005.003-.008.123-.544-.02-1.21-.314-1.908.011.329-.06.652-.24.944-.184.294-.507.397-.87.397-.558 0-1.204-.245-1.542-.414-.497-.25-1.347-1.23-1.965-1.23a.493.493 0 0 0-.409.211c-.114.15-.183.741-.3.956-.294.543-.68.658-1.124.66-.329 0-.63-.097-.92-.191-.29-.095-.573-.189-.87-.189a1.29 1.29 0 0 0-.518.106c-.687.292-1.344.469-2.02.469-.46 0-.926-.083-1.42-.266-.533-.197-2.778-.898-2.51-2.028.244-1.012 1.408-.503 1.168-2.13-.135-.876-.564-1.542-1.056-2.117-.037.04-.074.08-.108.123a7.056 7.056 0 0 0-.42.535 16.518 16.518 0 0 0-.5.8c.199 1.061.29 2.229.256 3.527-.02.824-.157 1.473-.38 1.98.123.04.243.076.366.114.183.054.363.111.538.169.466.148.895.297 1.275.454.106.046.209.089.31.135.033.017.068.031.102.048.4.192.732.398.973.624.002.003.005.006.005.008.14.132.249.272.323.424.04.005.08.008.118.014.314.037.626.063.938.063Z",
    fill: "#fff"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bc)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 62.339 16.635)",
    fill: "url(#bd)",
    d: "M0 0h16.738v9.444H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "be",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 33,
    height: 27
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M27.143 26.826c-.003 0-.006-.003-.008-.003l-.12-.025c-1.087-.223-3.25-.04-5.48-.218 2.23.178 4.395-.003 5.482.22l.126.026ZM16.077 24.65c-.718-.69-1.247-1.616-1.476-2.858a9.643 9.643 0 0 1-.145-1.727c-.003-1.267.188-2.589.443-3.71a8.108 8.108 0 0 1 0 .003c-.323 1.424-.546 3.175-.398 4.722.02.215.05.423.083.626.006.029.012.058.015.086.231 1.241.76 2.168 1.478 2.858Zm29.797-.827c.223-.506.36-1.156.38-1.98.035-1.298-.056-2.465-.257-3.526v-.003a14.41 14.41 0 0 0-.146-.678v.006c.006.014.009.029.012.043.231.981.369 2.05.395 3.238v.137l.002.043V21.549l-.002.072v.074c0 .023 0 .049-.003.072v.074c-.023.824-.158 1.473-.384 1.982h.003ZM35.73 20.288c1.25 0 2.071-1.373 3.124-2.1.42-.286.78-.391 1.112-.391.455 0 .858.197 1.281.397.427.197.873.398 1.416.398h.026c1.619-.02 1.65-1.725 1.645-3.447-.243.277-.615.378-1.004.378-.51 0-1.05-.175-1.37-.36-.81-.464-1.93-1.348-2.912-1.348-.323 0-.63.095-.907.332-.883.755-1.347 1.713-2.313 1.713-.21 0-.438-.046-.701-.143-1.968-.744-1.244-3.003-2.363-4.75-.715-1.119-1.541-1.697-2.42-1.697-.586 0-1.195.26-1.81.784-.6.518-1.473.7-1.976 1.353-.606.778-.518 2.008-1.384 2.488a2.65 2.65 0 0 1-1.279.335c-1.235 0-2.38-.924-2.24-2.86.075-1.036.264-2.003.16-3.058-.085-.827-.351-1.359-.637-1.916.42-.701.864-1.367 1.367-1.95.209-.244.426-.47.658-.682l.003-.003c.006-.005.011-.011.017-.014a.076.076 0 0 1 .017-.014 6.141 6.141 0 0 1 .337-.286c.639-.495 1.316-.792 2.008-1.036-.692.244-1.37.538-2.007 1.033-.981.764-1.73 1.836-2.426 2.989.552 2.088.058 2.886-.166 5.386-.151 1.664.072 3.884 1.113 4.95.62.633 1.324.865 2.062.865 1.816 0 3.85-1.39 5.397-1.625.14-.023.272-.032.4-.032.873 0 1.51.475 2.069 1.113.174.1.334.272.466.538.011.026.025.054.034.083.835 1.11 1.607 2.374 2.957 2.56.083.011.166.017.246.017ZM17.167 12.19c.383-.448.784-.886 1.178-1.344.278-.323.535-.666.781-1.027.003-.002.003-.005.006-.008.003-.006.009-.009.011-.014.458-.676.876-1.402 1.29-2.128-.643 1.12-1.29 2.245-2.087 3.174-.395.46-.796.899-1.179 1.348Zm24.875-1.327a29.783 29.783 0 0 0-.712-.786l-.398-.435c-1.273-1.407-2.551-3.009-3.555-4.736-.04-.072-.083-.143-.123-.215.04.072.08.143.123.212 1.107 1.913 2.554 3.666 3.953 5.177.243.26.483.52.712.783ZM35.12 1.602c-.549-.59-1.147-1.058-1.805-1.284a3.34 3.34 0 0 0-1.1-.18c-.51 0-1.022.103-1.528.26.506-.157 1.018-.26 1.524-.26.372 0 .741.054 1.104.18.658.229 1.256.695 1.805 1.284Z",
    fill: "#fff"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#be)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.139 26.825-.005-.003-.122-.025c-1.086-.223-3.25-.04-5.48-.218 2.23.178 4.399-.003 5.486.22.042.009.079.018.121.026Zm-12.54-5.034a9.635 9.635 0 0 1-.148-1.727c0-1.268.19-2.589.444-3.71a8.218 8.218 0 0 1 0 .003c-.322 1.424-.544 3.175-.396 4.722a7.722 7.722 0 0 0 .1.712Zm31.273 2.03c.222-.506.359-1.155.38-1.979a16.41 16.41 0 0 0-.259-3.526v-.003a13.842 13.842 0 0 0-.142-.678v.006c.005.014.005.028.01.043.233.98.37 2.05.396 3.238v.772c0 .023 0 .049-.005.071v.075c-.021.823-.158 1.473-.385 1.982h.005Zm-10.145-3.534c1.25 0 2.074-1.373 3.123-2.1.422-.286.781-.392 1.114-.392.453 0 .86.198 1.282.398.427.197.87.397 1.413.397h.027c1.62-.02 1.651-1.724 1.646-3.446-.243.277-.617.378-1.003.378a2.97 2.97 0 0 1-1.371-.36c-.813-.464-1.931-1.348-2.912-1.348-.322 0-.628.094-.908.332-.88.755-1.345 1.713-2.316 1.713-.205 0-.438-.046-.696-.143-1.968-.743-1.245-3.003-2.363-4.75-.718-1.12-1.54-1.697-2.422-1.697-.585 0-1.197.26-1.81.784-.6.518-1.471.7-1.978 1.353-.606.778-.517 2.008-1.382 2.488-.406.223-.85.335-1.276.335-1.24 0-2.385-.924-2.242-2.86.073-1.036.263-2.003.158-3.058-.085-.827-.348-1.358-.639-1.917.422-.7.866-1.367 1.372-1.95.206-.243.422-.469.654-.68l.005-.004c.006-.005.011-.011.016-.014.006-.006.01-.012.016-.014 0-.003.005-.006.005-.006a9.76 9.76 0 0 1 .333-.28c.638-.495 1.319-.793 2.01-1.036-.691.243-1.372.538-2.01 1.033-.982.764-1.73 1.836-2.422 2.989.549 2.088.053 2.886-.168 5.386-.154 1.664.073 3.884 1.113 4.95a2.766 2.766 0 0 0 2.062.864c1.815 0 3.851-1.39 5.397-1.624a2.52 2.52 0 0 1 .401-.031c.87 0 1.509.474 2.068 1.112.174.1.332.272.464.538.01.026.027.054.037.082.834 1.11 1.604 2.375 2.954 2.56.085.012.17.018.248.018Zm-18.564-8.098c.385-.449.786-.886 1.182-1.344a12.704 12.704 0 0 0 .786-1.035c0-.006.005-.01.01-.014.46-.676.876-1.402 1.293-2.129-.644 1.121-1.293 2.246-2.09 3.175-.395.46-.796.898-1.18 1.347Zm24.88-1.327c-.233-.263-.47-.523-.713-.786-.132-.143-.264-.29-.401-.435-1.271-1.407-2.548-3.01-3.556-4.736-.037-.072-.079-.143-.121-.215.042.072.08.143.121.211 1.108 1.914 2.554 3.667 3.957 5.177.243.261.48.521.712.784ZM35.12 1.601c-.554-.59-1.15-1.058-1.81-1.284a3.291 3.291 0 0 0-1.097-.18c-.512 0-1.023.102-1.53.26.506-.158 1.018-.26 1.525-.26a3.3 3.3 0 0 1 1.102.18c.66.228 1.256.695 1.81 1.284Z",
    fill: "url(#bf)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bg",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 13,
    width: 2,
    height: 4
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.663 16.928a13.93 13.93 0 0 0-.3-.884h-.003c.111.286.212.58.303.884Zm-.626-1.662a13.717 13.717 0 0 0-.69-1.319v.006c.092.155.18.312.266.47v.002c.152.275.292.555.424.841Z",
    fill: "#fff"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bg)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 45.895 13.78)",
    fill: "url(#bh)",
    d: "M0 0h1.722v3.295H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bi",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 15,
    width: 1,
    height: 2
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M45.363 16.04c-.1-.263-.209-.523-.326-.778.115.255.223.512.323.778h.003Z",
    fill: "#fff"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bi)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 45.603 15.071)",
    fill: "url(#bj)",
    d: "M0 0h.721v1.15H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bk",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 6,
    width: 2,
    height: 2
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20.434 7.679c.238-.415.475-.83.718-1.236V6.44c-.243.406-.48.824-.718 1.239Z",
    fill: "#fff"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bk)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 21.44 6.192)",
    fill: "url(#bl)",
    d: "M0 0h1.293v1.722H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bm",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 6,
    width: 27,
    height: 15
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M35.03 20.904c1.359 0 2.465-.735 3.807-1.222a1.95 1.95 0 0 1 .68-.117c.504 0 1.013.163 1.516.326.504.166 1.004.33 1.493.33.324 0 .641-.072.95-.267 1.496-.932 1.381-3.33 1.107-5.337a1.09 1.09 0 0 1-.249.53c.006 1.72-.026 3.426-1.645 3.446h-.025c-.544 0-.99-.2-1.416-.398-.423-.2-.827-.398-1.281-.398-.332 0-.693.106-1.113.392-1.053.727-1.873 2.1-3.123 2.1a1.8 1.8 0 0 1-.246-.018c-1.35-.185-2.123-1.45-2.958-2.56.178.476.02 1.26.166 1.763.272.963.838 1.2 1.582 1.352.26.052.512.078.755.078Zm-10.12-.29c1.565 0 3.101-.629 4.314-1.998.489-.55 1.521-1.64 2.37-1.64.152 0 .298.035.433.115-.558-.638-1.196-1.113-2.068-1.113-.129 0-.26.009-.4.032-1.548.234-3.581 1.624-5.398 1.624a2.765 2.765 0 0 1-2.062-.863c-1.04-1.067-1.264-3.287-1.112-4.951.223-2.5.718-3.298.166-5.386-.243.406-.48.82-.718 1.235-.415.727-.833 1.453-1.29 2.128.623-.915 1.17-1.924 1.742-2.903.26.896.266 1.894-.12 2.815-.438 1.04-1.136 1.619-1.485 2.746-.306.998-.232 1.132.054 1.996.192.578.387.878.36 1.553-.016.383-.257.784-.248 1.17.034 1.356 1.633 2.245 2.44 2.666.966.506 2.002.775 3.023.775Zm20.943-2.977a11.837 11.837 0 0 0-.495-1.602c-.1-.265-.209-.523-.323-.777a12.855 12.855 0 0 0 .818 2.38Z",
    fill: "#fff"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bm)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 46.469 6.193)",
    fill: "url(#bn)",
    d: "M0 0h27.749v15.88H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bo",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 13,
    width: 1,
    height: 1
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M44.268 13.81a.973.973 0 0 0-.057-.091l.057.09Z",
    fill: "#fff"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bo)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 44.464 13.481)",
    fill: "url(#bp)",
    d: "M0 0h.435v.578H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bq",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 3,
    width: 24,
    height: 13
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M35.831 15.863c.967 0 1.43-.958 2.314-1.713.277-.237.583-.332.907-.332.98 0 2.102.884 2.911 1.347.32.186.861.36 1.37.36.39 0 .761-.1 1.004-.377 0-.406-.003-.815.012-1.201l-.083-.137-.057-.092c-.16.532-.418.941-.804.941a.674.674 0 0 1-.206-.034c-.827-.29-1.304-2.174-1.896-2.929-1.568-2-4.07-1.482-5.417-4.104-.412-.798-.335-1.817-.736-2.572-.4-.752-1.27-1.393-1.927-1.533a1.826 1.826 0 0 0-.37-.046c-.497 0-.78.298-1.14.856-.324.5-.541.718-.899.718-.157 0-.34-.043-.572-.12-.64-.22-1.538-.61-2.362-.61-.595 0-1.15.203-1.547.815-.395.61-.092 1.23-.298 1.882-.232.724-.758.798-1.281.816-.032.002-.063.002-.095.002-1.395 0-2.09-1.078-2.677-2.625.18-.255.37-.498.567-.727-.504.584-.947 1.25-1.367 1.95.286.559.552 1.09.637 1.917.103 1.056-.085 2.022-.16 3.058-.14 1.936 1.004 2.86 2.24 2.86a2.65 2.65 0 0 0 1.278-.335c.867-.48.778-1.71 1.384-2.488.504-.652 1.376-.835 1.977-1.353.615-.523 1.224-.784 1.81-.784.878 0 1.705.578 2.42 1.697 1.118 1.747.395 4.007 2.362 4.75.264.098.492.143.701.143Z",
    fill: "#fff"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bq)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 44.605 3.192)",
    fill: "url(#br)",
    d: "M0 0h23.602v12.877H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bs",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 13,
    width: 1,
    height: 2
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M44.62 14.418v-.003a15.292 15.292 0 0 0 0 .003Z",
    fill: "#fff"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bs)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 44.893 13.773)",
    fill: "url(#bt)",
    d: "M0 0h.721v.864H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bu",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 13,
    width: 1,
    height: 3
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M44.343 15.146a1.09 1.09 0 0 0 .248-.529 11.897 11.897 0 0 0-.045-.337 12.6 12.6 0 0 0-.192-.335c-.014.386-.011.795-.011 1.201Z",
    fill: "#fff"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 44.893 13.771)",
    fill: "url(#bv)",
    d: "M0 0h.721v1.579H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bw",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 10,
    width: 3,
    height: 4
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M44.023 13.4a21.618 21.618 0 0 0-1.968-2.54 24.947 24.947 0 0 1 1.444 1.782c.18.25.355.504.523.758Z",
    fill: "#fff"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bw)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 44.185 10.62)",
    fill: "url(#bx)",
    d: "M0 0h2.294v3.009H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "by",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 10,
    width: 3,
    height: 3
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M43.491 12.653a24.948 24.948 0 0 0-1.444-1.782 29.982 29.982 0 0 0-.712-.783c.79.85 1.515 1.687 2.156 2.565Z",
    fill: "#fff"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#by)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 43.748 2.195)",
    fill: "url(#bz)",
    d: "M0 0h20.742v10.732H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bA",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 13,
    width: 1,
    height: 1
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M44.206 13.718c.003 0 .003 0 .003-.003l-.197-.308c.066.102.131.205.194.31Z",
    fill: "#fff"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bA)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 44.464 13.204)",
    fill: "url(#bB)",
    d: "M0 0h.721v.721H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bC",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 12,
    width: 2,
    height: 2
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M44.209 13.718c-.063-.106-.129-.209-.195-.312a16.191 16.191 0 0 1 .195.312Z",
    fill: "#fff"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bC)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 44.464 12.49)",
    fill: "url(#bD)",
    d: "M0 0h1.15v1.436H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bE",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 0,
    width: 4,
    height: 2
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M27.122 1.912c.074-.026.149-.051.223-.08h-.003l-.22.08Zm1.376-.58C29.2.996 29.942.635 30.69.398c-.752.237-1.493.598-2.196.932h.003Z",
    fill: "#fff"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bE)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 30.878 .186)",
    fill: "url(#bF)",
    d: "M0 0h4.01v2.008H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bG",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 1,
    width: 4,
    height: 2
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M25.592 2.41c.51-.174 1.024-.323 1.533-.5-.512.174-1.027.323-1.533.5Zm1.756-.58c.232-.083.46-.178.69-.284.151-.068.308-.143.463-.217h-.003c-.154.074-.309.146-.46.217-.23.106-.46.198-.692.284h.002Z",
    fill: "#fff"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bG)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 28.74 1.046)",
    fill: "url(#bH)",
    d: "M0 0h3.295v1.579H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bI",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 0,
    width: 24,
    height: 15
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M43.405 14.655c.386 0 .644-.409.804-.94-.223-.364-.463-.722-.718-1.07-.64-.878-1.367-1.717-2.156-2.566-1.4-1.51-2.846-3.264-3.953-5.177A31.945 31.945 0 0 0 36.24 3.04a12.085 12.085 0 0 0-1.116-1.439c-.549-.589-1.147-1.055-1.804-1.284a3.345 3.345 0 0 0-1.104-.18c-.507 0-1.019.103-1.525.26-.75.238-1.49.598-2.194.933a21.89 21.89 0 0 1-.463.217c-.229.106-.458.2-.69.283-.074.029-.148.054-.223.08-.509.178-1.023.326-1.532.5-.693.244-1.37.541-2.008 1.036a6.103 6.103 0 0 0-.338.286c-.006.003-.011.009-.017.014a.074.074 0 0 0-.017.015l-.003.003c-.232.211-.449.437-.658.68a9.652 9.652 0 0 0-.566.727c.586 1.547 1.281 2.625 2.677 2.625.031 0 .063 0 .094-.002.524-.018 1.05-.092 1.282-.816.206-.652-.098-1.272.297-1.882.398-.612.953-.815 1.548-.815.823 0 1.721.39 2.362.61.232.077.415.12.572.12.357 0 .575-.218.898-.718.36-.558.644-.855 1.141-.855.112 0 .232.017.37.045.657.14 1.527.781 1.927 1.533.4.755.323 1.774.735 2.572 1.347 2.622 3.85 2.105 5.417 4.104.592.755 1.07 2.64 1.896 2.929.072.023.14.034.206.034Z",
    fill: "#fff"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bI)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 44.464 -.1)",
    fill: "url(#bJ)",
    d: "M0 0h22.744v15.022H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bK",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 17,
    width: 1,
    height: 1
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M32.527 17.715c-.008-.028-.023-.057-.034-.082-.132-.267-.292-.438-.466-.538.174.194.337.403.5.62Z",
    fill: "#fff"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bK)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 46.469 9.625)",
    fill: "url(#bL)",
    d: "M0 0h28.321v12.305H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bM",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 24,
    width: 6,
    height: 3
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M21.546 26.575c-2.017-.163-4.084-.618-5.457-1.93 1.373 1.312 3.44 1.77 5.457 1.93Z",
    fill: "#fff"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bM)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 21.729 24.497)",
    fill: "url(#bN)",
    d: "M0 0h5.869v2.294H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bO",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 6,
    width: 33,
    height: 21
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.136 26.816c-.052-.02-.097-.043-.143-.065-.22-.106-.383-.23-.478-.375-.16-.24-.125-.52-.003-.78.058-.124.135-.244.224-.356.268-.334.812-.572 1.444-.792.349-.12.726-.237 1.098-.357.67-.22 1.193-.492 1.73-.758.112-.055.227-.109.341-.163a8.09 8.09 0 0 1 1.79-.624c.524-.117 1.087-.18 1.656-.234.544-.052 1.096-.092 1.63-.164.656-.085 1.365-.191 2.086-.248.317-.029.635-.043.952-.046h.052c.271 0 .543.011.812.037 1.11.109 1.996.48 2.717.824l.28.134c.721.352 1.634.678 2.549.967.226-.51.36-1.158.383-1.982v-.074c.003-.023.003-.05.003-.072v-.074l.003-.072V21.096l-.003-.043v-.137a15.482 15.482 0 0 0-.406-3.28v-.007a12.95 12.95 0 0 0-1.242-3.22 1.402 1.402 0 0 1-.028.2c.274 2.008.389 4.405-1.107 5.337a1.73 1.73 0 0 1-.95.266c-.489 0-.99-.163-1.493-.329-.503-.163-1.012-.326-1.516-.326-.228 0-.454.035-.68.117-1.342.487-2.448 1.222-3.807 1.222-.243 0-.495-.026-.755-.078-.744-.151-1.31-.388-1.582-1.352-.146-.504.012-1.287-.166-1.762a9.119 9.119 0 0 0-.5-.62.829.829 0 0 0-.432-.115c-.85 0-1.882 1.09-2.371 1.639-1.213 1.37-2.749 1.999-4.313 1.999-1.021 0-2.057-.269-3.023-.775-.807-.42-2.406-1.31-2.44-2.666-.009-.386.232-.787.249-1.17.026-.675-.169-.975-.36-1.553-.287-.864-.361-.998-.055-1.996.349-1.127 1.047-1.705 1.485-2.746.386-.921.38-1.92.12-2.815-.572.979-1.119 1.988-1.742 2.904-.003.005-.009.008-.012.014-.002.003-.002.006-.005.008-.246.36-.504.704-.781 1.027-.395.458-.795.896-1.178 1.345-.655.766-1.259 1.558-1.71 2.53a8.1 8.1 0 0 0-.559 1.634c-.254 1.121-.446 2.443-.443 3.71 0 .598.046 1.181.146 1.727.229 1.242.758 2.168 1.476 2.858 1.373 1.313 3.44 1.767 5.457 1.93 2.23.178 4.393-.005 5.48.218l.12.025Z",
    fill: "#fff"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bO)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 46.469 6.62)",
    fill: "url(#bP)",
    d: "M0 0h32.182v20.456H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bQ",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 14,
    width: 1,
    height: 1
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M44.592 14.618c.014-.063.022-.128.028-.2a3.17 3.17 0 0 0-.074-.136c.017.11.031.222.046.336Z",
    fill: "#fff"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bQ)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 44.893 14.06)",
    fill: "url(#bR)",
    d: "M0 0h.578v.721H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bS",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 22,
    width: 24,
    height: 6
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M38.172 27.514c.512 0 1.024-.015 1.533-.055.815-.063 1.625-.166 2.446-.248-.821.082-1.63.185-2.443.248-.512.04-1.027.055-1.539.055-.832 0-1.664-.04-2.49-.089-.456-.029-1.165-.026-1.992-.029.83.003 1.54 0 1.994.029.827.049 1.659.089 2.491.089Zm10.809-.487c.523-.111.866-.306.898-.637.02-.215-.02-.412-.109-.595a1.476 1.476 0 0 0-.149-.235c.16.206.252.432.26.684v.097c0 .003 0 .009-.002.011V26.39c-.032.331-.378.526-.898.637Zm-22.464-.649a.672.672 0 0 1-.108-.36c0-.14.04-.283.105-.42-.123.26-.157.54.003.78Zm15.594-.314c.923 0 1.527-.287 2.305-.438.309-.06.575-.083.818-.083.337 0 .635.043.95.083.311.043.643.083 1.043.083h.018c1.195-.003 1.218-.36 1.215-.718-.18.057-.455.077-.74.077-.378 0-.776-.034-1.013-.074-.598-.097-1.425-.28-2.148-.28-.237 0-.466.02-.67.068-.652.157-.992.358-1.707.358-.151 0-.323-.009-.518-.029-1.45-.157-.918-.63-1.744-.992a4.389 4.389 0 0 0-1.785-.355 5.74 5.74 0 0 0-1.336.163c-.443.109-1.087.146-1.458.283-.447.163-.38.42-1.024.52a6.304 6.304 0 0 1-.941.07c-.913 0-1.756-.192-1.653-.598.057-.215.194-.418.117-.638-.06-.175-.258-.283-.47-.4.313-.147.641-.287 1.013-.41.006 0 .009-.003.015-.003 0-.002.002-.002.002-.002.16-.052.332-.1.512-.146l.029-.009c.003 0 .006 0 .009-.003.005 0 .011-.003.017-.003l.02-.005c.005 0 .011-.003.014-.003.006 0 .009-.003.014-.003.006-.003.009-.003.015-.003.008-.003.014-.006.023-.006.005-.003.008-.003.011-.003l.02-.005c.006 0 .011-.003.02-.003.003-.003.006-.003.011-.003a.082.082 0 0 1 .026-.006c.526-.117 1.087-.18 1.656-.234-.569.054-1.132.117-1.656.234a8.085 8.085 0 0 0-1.79.624c.409.435.043.6-.12 1.124-.112.346.051.812.82 1.032.458.135.976.18 1.522.18 1.339 0 2.84-.288 3.981-.337.103-.006.2-.008.298-.008.643 0 1.113.1 1.527.234a1.034 1.034 0 0 1 .37.129c.614.232 1.183.495 2.179.535.063.003.123.003.183.003ZM28.18 24.45c.35-.12.727-.234 1.099-.357a8.6 8.6 0 0 0 .718-.275c.357-.154.68-.32 1.012-.483-.537.266-1.06.538-1.73.758-.372.12-.75.237-1.098.357Zm18.062-.517a18.35 18.35 0 0 1-.366-.115h-.003c-.915-.289-1.827-.615-2.548-.966-.091-.043-.183-.09-.28-.135l.28.135c.818.4 1.885.766 2.917 1.08Z",
    fill: "#fff"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bS)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.176 27.514c.51 0 1.025-.015 1.53-.055.816-.063 1.627-.165 2.45-.249-.823.084-1.634.186-2.446.25-.51.04-1.024.054-1.54.054-.832 0-1.664-.04-2.491-.09-.453-.028-1.16-.025-1.987-.028.827.003 1.534 0 1.992.029.827.049 1.66.089 2.492.089Zm10.804-.487c.526-.111.87-.306.9-.637a1.1 1.1 0 0 0-.109-.596 1.444 1.444 0 0 0-.145-.234c.156.206.25.432.26.684v.097c0 .003 0 .008-.006.011V26.39c-.03.331-.38.526-.9.637Zm-22.462-.649a.707.707 0 0 1-.11-.36c0-.14.042-.284.11-.42-.125.26-.161.54 0 .78Zm15.596-.315c.92 0 1.524-.285 2.304-.437.307-.06.572-.083.817-.083.338 0 .635.043.952.083.312.043.64.083 1.04.083h.021c1.197-.003 1.218-.36 1.212-.718-.177.057-.452.077-.738.077a6.8 6.8 0 0 1-1.015-.074c-.598-.098-1.42-.28-2.148-.28-.234 0-.463.02-.666.068-.656.158-.994.358-1.706.358a5.08 5.08 0 0 1-.52-.029c-1.452-.157-.916-.63-1.743-.992a4.397 4.397 0 0 0-1.785-.355c-.431 0-.884.054-1.337.163-.442.108-1.087.146-1.461.283-.443.163-.38.42-1.02.52a6.353 6.353 0 0 1-.941.07c-.916 0-1.759-.192-1.655-.599.057-.214.193-.417.115-.637-.058-.175-.255-.283-.469-.4a9.02 9.02 0 0 1 1.015-.41l.015-.002v-.004c.162-.051.333-.1.515-.145l.027-.01.01-.002.015-.003c.01-.002.016-.002.021-.006l.016-.002c.005 0 .005-.003.01-.003.01-.003.01-.003.016-.003.01-.003.016-.006.026-.006.005-.003.005-.003.01-.003l.021-.005c.005 0 .01-.003.016-.003.005-.003.01-.003.015-.003a.064.064 0 0 1 .026-.006c.526-.117 1.088-.18 1.655-.234-.567.054-1.134.117-1.655.234a8.215 8.215 0 0 0-1.794.624c.41.435.046.6-.12 1.124-.11.346.052.812.822 1.032.458.135.978.18 1.524.18 1.337 0 2.84-.288 3.98-.337.104-.006.197-.008.296-.008.645 0 1.114.1 1.53.234a1.045 1.045 0 0 1 .369.129c.614.231 1.18.495 2.18.535.062.002.12.002.182.002ZM28.183 24.45c.348-.12.728-.234 1.097-.357.26-.086.5-.178.718-.275.359-.155.682-.32 1.014-.483-.535.266-1.06.538-1.732.758-.37.12-.749.237-1.098.357Zm18.061-.517-.364-.115h-.005c-.916-.289-1.826-.615-2.55-.967.823.401 1.89.767 2.92 1.082Z",
    fill: "url(#bT)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bU",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 24,
    width: 2,
    height: 2
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M49.441 25.37c-.24-.227-.572-.433-.972-.624.066.031.132.066.197.097.312.166.575.338.776.526Z",
    fill: "#fff"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bU)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 49.61 24.504)",
    fill: "url(#bV)",
    d: "M0 0h1.293v1.15H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bW",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 23,
    width: 21,
    height: 4
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M41.595 26.206c1.004 0 1.82-.155 2.809-.255.168-.017.334-.026.503-.026.372 0 .747.035 1.119.069.371.034.74.069 1.1.069.24 0 .475-.015.704-.055 1.104-.194 1.018-.695.815-1.115-.031.046-.097.083-.183.111.003.358-.02.715-1.215.718h-.017c-.4 0-.733-.04-1.044-.083-.315-.04-.612-.083-.95-.083-.243 0-.509.023-.818.083-.778.152-1.381.438-2.305.438-.06 0-.12 0-.183-.003-.996-.04-1.565-.303-2.18-.535.129.1.012.263.12.37.2.2.618.248 1.167.282.195.009.378.015.558.015Zm-7.468-.06c1.156 0 2.288-.132 3.184-.418.36-.115 1.12-.343 1.75-.343.112 0 .217.008.32.025a4.734 4.734 0 0 0-1.527-.234c-.097 0-.194.003-.297.009-1.142.048-2.643.337-3.982.337-.546 0-1.064-.046-1.521-.18-.77-.22-.933-.687-.821-1.033.163-.523.529-.69.12-1.124l-.34.163c-.332.163-.655.33-1.013.484.406-.175.775-.367 1.156-.552.194.188.197.397-.089.589-.32.217-.838.337-1.093.572-.228.209-.171.237.038.417.143.12.286.183.268.324-.014.08-.191.166-.186.246.026.283 1.207.469 1.802.555a15.37 15.37 0 0 0 2.231.162Zm15.496-.573a1.534 1.534 0 0 0-.18-.197c-.2-.189-.463-.36-.775-.526v.003c.418.217.747.452.956.72Z",
    fill: "#fff"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bW)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 50.044 22.936)",
    fill: "url(#bX)",
    d: "M0 0h20.456v3.724H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bY",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 24,
    width: 1,
    height: 1
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m48.47 24.751-.102-.049c.034.017.068.035.103.049Z",
    fill: "#fff"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bY)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 48.763 24.504)",
    fill: "url(#bZ)",
    d: "M0 0h.578v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ca",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 22,
    width: 18,
    height: 4
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M42.184 25.15c.715 0 1.056-.2 1.708-.357.203-.049.431-.069.669-.069.724 0 1.55.183 2.148.28.237.04.635.075 1.012.075.286 0 .561-.02.741-.077a1.461 1.461 0 0 1 .009-.252c-.035-.014-.069-.032-.103-.049-.12.112-.31.198-.595.198-.049 0-.097-.003-.152-.006-.609-.06-.96-.455-1.398-.612-1.159-.418-3.004-.309-3.999-.858-.303-.166-.246-.378-.543-.538-.295-.157-.935-.289-1.422-.32a4.759 4.759 0 0 0-.271-.009 1.84 1.84 0 0 0-.844.18 1.465 1.465 0 0 1-.664.15c-.114 0-.249-.01-.42-.027-.472-.045-1.136-.126-1.742-.126-.44 0-.852.043-1.144.17-.292.128-.069.257-.22.394-.169.149-.558.166-.947.169h-.066c-1.032 0-1.544-.223-1.976-.547a9.083 9.083 0 0 0-.592.255c.212.117.409.226.469.4.077.22-.06.424-.117.638-.103.406.74.598 1.653.598.317 0 .643-.023.94-.069.644-.1.579-.357 1.025-.52.371-.137 1.015-.175 1.458-.283a5.74 5.74 0 0 1 1.336-.163c.65 0 1.258.12 1.785.354.826.363.294.835 1.744.993.195.02.367.028.518.028Z",
    fill: "#fff"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ca)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 48.763 22.357)",
    fill: "url(#cb)",
    d: "M0 0h17.596v3.009H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cc",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 24,
    width: 1,
    height: 1
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M48.462 24.992c.086-.028.152-.066.183-.111l-.034-.069c.02.009.037.017.057.029v-.003l-.197-.098c-.012.08-.012.166-.009.252Z",
    fill: "#fff"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 48.905 24.495)",
    fill: "url(#cd)",
    d: "M0 0h.721v.721H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ce",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 24,
    width: 3,
    height: 1
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M48.054 24.554a16.579 16.579 0 0 0-.324-.126c.112.043.218.083.324.126Z",
    fill: "#fff"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ce)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 48.327 23.925)",
    fill: "url(#cf)",
    d: "M0 0h1.722v.864H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cg",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 23,
    width: 2,
    height: 2
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M47.733 24.434c-.294-.112-.612-.22-.952-.33a25.178 25.178 0 0 1 .952.329Z",
    fill: "#fff"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cg)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 47.897 22.354)",
    fill: "url(#ch)",
    d: "M0 0h15.736v2.294H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ci",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 24,
    width: 2,
    height: 1
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M48.37 24.694c-.101-.045-.204-.088-.31-.134-.106-.043-.211-.083-.323-.126.226.086.435.172.632.26Z",
    fill: "#fff"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ci)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 48.614 24.207)",
    fill: "url(#cj)",
    d: "M0 0h1.15v.721H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ck",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 21,
    width: 7,
    height: 2
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M40.335 21.896a8.544 8.544 0 0 0-.813-.037h-.051.049c.274 0 .546.011.815.037Zm-5.532.42c.544-.048 1.096-.091 1.63-.163-.534.072-1.087.112-1.63.163Z",
    fill: "#fff"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ck)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 43.327 21.634)",
    fill: "url(#cl)",
    d: "M0 0h8.729v1.293H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cm",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 21,
    width: 18,
    height: 4
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M47.774 24.894c.286 0 .475-.086.595-.198a11.467 11.467 0 0 0-.632-.26c-.446-.169-.95-.332-1.49-.498-1.033-.314-2.1-.68-2.917-1.08l-.28-.135c-.721-.344-1.608-.715-2.718-.824a8.564 8.564 0 0 0-.815-.037h-.049c-.317.003-.635.017-.952.046-.72.057-1.43.162-2.085.248-.535.072-1.087.115-1.63.163-.57.055-1.13.118-1.656.235-.009 0-.018.003-.026.006-.006 0-.009 0-.011.003l-.02.002c-.01.003-.015.003-.02.006-.003 0-.006 0-.012.003-.009 0-.014.003-.023.006-.006 0-.008 0-.014.003l-.014.002-.015.003c-.006.003-.011.003-.02.006-.005 0-.011.003-.017.003-.003.003-.006.003-.009.003l-.028.008a8.61 8.61 0 0 0-.512.146s-.003 0-.003.003c-.006 0-.009.003-.014.003-.146.048-.286.1-.42.154.431.323.943.547 1.976.547h.065c.39-.003.778-.02.947-.17.152-.137-.071-.265.22-.394.292-.126.704-.169 1.144-.169.607 0 1.27.08 1.742.126.172.017.306.026.42.026.267 0 .427-.046.664-.149a1.84 1.84 0 0 1 .844-.18c.08 0 .172.003.272.009.486.031 1.127.163 1.421.32.298.16.24.372.544.538.995.549 2.84.44 3.998.858.438.157.79.552 1.399.612.054.003.103.006.151.006Z",
    fill: "#fff"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cm)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 48.614 21.635)",
    fill: "url(#cn)",
    d: "M0 0h16.881v3.438H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "co",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 25,
    width: 1,
    height: 1
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m39.75 25.535-.028-.018a1.034 1.034 0 0 0-.34-.111c.125.04.248.083.368.129Z",
    fill: "#fff"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#co)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 50.044 23.65)",
    fill: "url(#cp)",
    d: "M0 0h21.028v3.581H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cq",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 26,
    width: 7,
    height: 2
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M33.688 27.403c-2.18-.002-5.177-.017-6.539-.575h-.003c1.362.558 4.362.573 6.541.575Z",
    fill: "#fff"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cq)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 33.88 26.642)",
    fill: "url(#cr)",
    d: "M0 0h7.013v1.007H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cs",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 26,
    width: 1,
    height: 1
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M27.15 26.826c-.005 0-.008-.003-.01-.003.002 0 .005.003.008.003h.002Z",
    fill: "#fff"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cs)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 27.307 26.64)",
    fill: "url(#ct)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cu",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 26,
    width: 1,
    height: 1
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M27.145 26.816Z",
    fill: "#fff"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cu)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 27.311 26.495)",
    fill: "url(#cv)",
    d: "M0 0h.578v.578H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cw",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 27,
    width: 7,
    height: 1
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M42.157 27.223c.592-.06 1.187-.109 1.794-.12.074-.003.154-.003.234-.003.42 0 .915.017 1.436.037.518.017 1.064.037 1.584.037.673 0 1.302-.031 1.782-.134-.48.103-1.112.134-1.784.134-.518 0-1.062-.02-1.58-.037a39.04 39.04 0 0 0-1.432-.037c-.083 0-.163 0-.243.002a21.8 21.8 0 0 0-1.79.12Z",
    fill: "#fff"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cw)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 49.19 26.794)",
    fill: "url(#cx)",
    d: "M0 0h7.299v.578H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cy",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 24,
    height: 5
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M38.172 27.514c.512 0 1.026-.015 1.538-.055.813-.063 1.622-.166 2.443-.248.592-.06 1.187-.11 1.79-.12.08-.004.16-.004.243-.004.42 0 .913.018 1.433.038.518.017 1.061.037 1.58.037.671 0 1.303-.032 1.784-.135.52-.111.867-.306.898-.637v-.038c.003-.002.003-.008.003-.011v-.097a1.158 1.158 0 0 0-.26-.684c-.21-.269-.538-.503-.956-.72a.11.11 0 0 1-.023.04c.203.42.29.92-.815 1.115a4.08 4.08 0 0 1-.703.054c-.36 0-.73-.034-1.102-.068a12.23 12.23 0 0 0-1.118-.069c-.169 0-.334.009-.503.026-.99.1-1.805.254-2.809.254-.18 0-.363-.006-.558-.014-.549-.034-.966-.083-1.166-.283-.11-.106.008-.27-.12-.37a7.103 7.103 0 0 0-.37-.128 1.945 1.945 0 0 0-.32-.026c-.63 0-1.39.23-1.75.344-.896.286-2.028.417-3.184.417a15.37 15.37 0 0 1-2.23-.163c-.595-.086-1.777-.272-1.802-.555-.006-.08.171-.166.185-.246.018-.14-.125-.203-.268-.323-.21-.18-.266-.209-.038-.418.255-.234.773-.354 1.093-.572.286-.191.283-.4.089-.589-.38.186-.75.378-1.156.552a8.6 8.6 0 0 1-.718.275c-.372.123-.75.237-1.098.357-.632.22-1.175.458-1.444.793a1.795 1.795 0 0 0-.223.354.983.983 0 0 0-.106.42.672.672 0 0 0 .108.361c.095.146.258.269.478.375.046.023.094.046.143.066.003 0 .006.003.011.003 1.362.557 4.36.572 6.539.574.826.003 1.536 0 1.99.029.827.049 1.66.089 2.492.089Z",
    fill: "#fff"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cy)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 50.044 23.067)",
    fill: "url(#cz)",
    d: "M0 0h23.888v4.725H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cA",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 24,
    width: 1,
    height: 1
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M48.645 24.89a.111.111 0 0 0 .023-.039.533.533 0 0 0-.057-.028l.034.068Z",
    fill: "#fff"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cA)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 48.905 24.65)",
    fill: "url(#cB)",
    d: "M0 0h.435v.435H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cC",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 21,
    width: 15,
    height: 9
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M25.985 28.697c-.171-.76-.552-1.49-1.187-1.968a2.859 2.859 0 0 0-.89-.435c-.162-.045-.32-.028-.445-.125.36-.255 1.138.034 1.521.143 1.136.314 1.8.637 2.626 1.51-.123-.506-.06-.956-.323-1.45-.206-.387-.578-.735-.744-1.104 1.101.283 1.776 1.716 2.177 2.625-.724-1.681.251-2.957 1.484-3.987a4.9 4.9 0 0 0-.395.758c-.372.864-.097 1.648.12 2.563.21-.801.756-1.753 1.468-2.245-.275.563.094 1.332.248 1.89.238-.223.255-.826.306-1.15.098-.586.15-1.2.16-1.799.018-1.024-.217-1.947-.557-2.9.59.366 1.012 1.216 1.253 1.845.509 1.327.523 2.46.254 3.864.535-.632 1.084-1.253 1.868-1.65.952-.484 2.01-.143 2.98-.41-.54.167-1.118.361-1.647.61-1.059.498-1.622 1.118-2.185 2.148.471-.152.963-.406 1.538-.415.638-.008 1.267.272 1.874.263-1.216-.031-2.26.384-3.146 1.202.082-.284.125-.624.311-.85-.798.057-1.29.692-1.59 1.364-.043-.4-.132-.912-.126-1.312.112-.103.206-.26.318-.386a1.446 1.446 0 0 0-.878.526c-.326.389-.355 1.067-.692 1.39-.12-.667-.28-1.244-.764-1.72-.123.264-.166.573-.212.856-.043.263.049.752-.069.941-.34-.44-.869-.981-.883-1.576-.203.41-.495.884-.518 1.347-.046-.26-.186-.575-.089-.812-.529.114-.543.415-.875.78-.02-.288-.143-.72-.046-.96-.397-.012-.737.818-.74 1.161-.41-.572-.867-1.276-1.542-1.564.183.277.212.752.037 1.032Z",
    fill: "#fff"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cC)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.981 28.696c-.172-.76-.553-1.49-1.185-1.967a2.86 2.86 0 0 0-.892-.435c-.162-.046-.319-.029-.444-.126.36-.255 1.138.034 1.52.143 1.137.314 1.8.638 2.625 1.51-.12-.506-.058-.955-.319-1.45-.208-.386-.58-.735-.746-1.104 1.101.283 1.775 1.716 2.177 2.626-.726-1.682.25-2.958 1.482-3.987a4.763 4.763 0 0 0-.391.758c-.371.863-.1 1.647.12 2.562.209-.8.751-1.753 1.467-2.245-.277.563.093 1.333.25 1.89.235-.223.25-.826.303-1.15.099-.586.151-1.2.162-1.798.015-1.024-.22-1.948-.559-2.9.59.365 1.013 1.215 1.253 1.844.511 1.327.522 2.46.256 3.864.532-.632 1.08-1.253 1.868-1.65.95-.483 2.01-.143 2.981-.41-.543.167-1.122.362-1.65.61-1.059.498-1.623 1.119-2.187 2.148.475-.151.966-.406 1.54-.414.637-.01 1.269.271 1.874.263-1.216-.032-2.26.383-3.147 1.201.083-.283.125-.624.313-.85-.799.057-1.29.693-1.592 1.365-.042-.4-.13-.913-.126-1.313.115-.103.21-.26.319-.387a1.436 1.436 0 0 0-.877.527c-.329.39-.355 1.067-.694 1.39-.12-.666-.277-1.244-.762-1.719-.126.263-.168.572-.215.855-.041.263.053.753-.067.941-.34-.44-.867-.98-.883-1.576-.203.41-.495.884-.516 1.347-.047-.26-.188-.574-.09-.812-.532.114-.542.415-.876.781-.02-.289-.141-.72-.047-.96-.397-.012-.736.817-.741 1.16-.407-.572-.867-1.275-1.54-1.564.183.277.214.752.036 1.032Z",
    fill: "url(#cD)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cE",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 20,
    width: 11,
    height: 7
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M51.682 26.893c-.409-.57-.892-.798-1.521-1.024.197-.126.466-.126.698-.12.643.011 1.055.186 1.627.52.006-.214-.197-.48-.309-.657a9.435 9.435 0 0 0-.477-.684c-.272-.369-.653-.552-.959-.872.206-.037.507.126.69.223.706.372 1.078.852 1.579 1.49.037-1.118-.338-2.385-.704-3.435-.226-.64-.658-1.167-1.098-1.662.569-.192 1.407.801 1.684 1.159.741.96 1.239 2.23 1.445 3.415.168-.452.117-.939.323-1.396.189-.424.503-.735.798-1.087.415-.492.952-.878 1.467-1.253-.209.526-.592.995-.83 1.519-.34.764-.54 1.619-.772 2.417.46-.687.99-1.242 1.77-1.579.464-.203.99-.297 1.494-.312.177-.006.58-.077.73.04-.124.163-.493.175-.676.223a3.07 3.07 0 0 0-.904.395c-.317.2-.609.41-.904.638-.457.355-.706.698-.986 1.238.437-.469 1.233-.689 1.865-.723.586-.035 1.204.071 1.764.246.21.066.486.106.672.211-.206.017-.417-.054-.626-.071-.435-.034-.878.023-1.31.083-.964.134-1.805.395-2.588.978.063-.26.071-.366.271-.503a1.159 1.159 0 0 0-.552.134c-.1.057-.3.286-.343.269.117-.59.009-.921-.183-1.465-.091.103-.057.372-.077.521-.049.329-.18.61-.18.944-.355-.724-.647-1.216-1.305-1.665.212.25.387.547.43.878.025.203.04.836-.132.967-.186-.177-.492-.489-.778-.572.069.197.203.478.175.672-.41-.303-.853-.592-1.36-.7.104.134.178.491.092.6Z",
    fill: "#fff"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cE)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.684 26.893c-.41-.57-.895-.798-1.522-1.024.198-.126.465-.126.698-.12.642.011 1.057.186 1.628.52.005-.214-.197-.48-.308-.657-.147-.238-.314-.46-.48-.684-.269-.369-.653-.552-.956-.873.207-.037.505.126.688.223.707.373 1.076.853 1.577 1.491.04-1.118-.334-2.386-.703-3.435-.222-.64-.657-1.167-1.097-1.662.571-.192 1.406.8 1.684 1.159.743.96 1.239 2.23 1.446 3.414.167-.451.116-.938.323-1.395.188-.424.501-.736.8-1.088.414-.491.95-.877 1.466-1.252-.208.526-.592.995-.83 1.519-.343.764-.54 1.619-.773 2.416.46-.686.99-1.24 1.77-1.578a4.07 4.07 0 0 1 1.491-.312c.182-.006.581-.077.733.04-.126.163-.495.175-.677.223a3.108 3.108 0 0 0-.905.395c-.314.2-.607.409-.9.638-.46.354-.708.698-.986 1.238.434-.469 1.228-.69 1.86-.723.587-.035 1.209.07 1.765.246.212.066.49.105.672.211-.202.017-.414-.054-.627-.071-.434-.035-.874.023-1.31.083-.96.134-1.804.394-2.588.978.066-.26.076-.366.273-.503a1.158 1.158 0 0 0-.551.134c-.101.057-.298.286-.344.268.117-.588.01-.92-.182-1.464-.09.103-.056.372-.076.521-.05.329-.182.61-.182.944-.354-.724-.647-1.216-1.304-1.665.212.249.384.547.43.878.025.203.04.835-.132.967-.187-.177-.49-.49-.779-.572.071.197.203.477.177.672-.41-.303-.854-.592-1.36-.7.101.134.177.491.091.6Z",
    fill: "url(#cF)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "aX",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dp",
    transform: "scale(.01136 .05263)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "n",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cG",
    transform: "scale(.00606 .0097)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "t",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cJ",
    transform: "scale(.0053 .01053)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "v",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cK",
    transform: "scale(.07143 .0909)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "x",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cL",
    transform: "scale(.125 .11111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "z",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cM",
    transform: "scale(.00575 .0147)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "B",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cN",
    transform: "scale(.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "D",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cO",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "F",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cP",
    transform: "scale(.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "H",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cQ",
    transform: "scale(.11111 .1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "J",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cR",
    transform: "scale(.1 .0909)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "L",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cS",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "N",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cS",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "P",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cT",
    transform: "scale(.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "R",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cU",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "T",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cV",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "V",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cU",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "X",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cV",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Z",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cW",
    transform: "scale(.14286 .2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ab",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cX",
    transform: "scale(.25 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ad",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cY",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "af",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cZ",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ah",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#da",
    transform: "scale(.33333 .25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aj",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#db",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "al",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#db",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "an",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#db",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ap",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dc",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ar",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dc",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "at",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dc",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "av",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dd",
    transform: "scale(.01333 .06667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ax",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#de",
    transform: "scale(.00685 .01852)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aD",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#df",
    transform: "scale(.02941 .03571)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aF",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dg",
    transform: "scale(.03571 .16667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aH",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dh",
    transform: "scale(.03226 .25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aJ",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#di",
    transform: "scale(.0145 .02564)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aL",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dj",
    transform: "scale(.07692 .1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aN",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dk",
    transform: "scale(.07692 .1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aP",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dl",
    transform: "scale(.1 .05263)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aR",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dm",
    transform: "scale(.009 .0147)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aT",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dn",
    transform: "scale(.14286 .11111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aV",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#do",
    transform: "scale(.16667 .125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "r",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cI",
    transform: "scale(.07692 .04)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aZ",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dq",
    transform: "scale(.1 .08333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bb",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dr",
    transform: "scale(.16667 .125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bd",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ds",
    transform: "scale(.00855 .01515)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bh",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dt",
    transform: "scale(.08333 .04348)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bj",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#du",
    transform: "scale(.2 .125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bl",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dv",
    transform: "scale(.11111 .08333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bn",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dw",
    transform: "scale(.00515 .009)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bp",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dx",
    transform: "scale(.33333 .25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "br",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dy",
    transform: "scale(.00606 .01111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bt",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dz",
    transform: "scale(.2 .16667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bv",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dA",
    transform: "scale(.2 .0909)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bx",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dB",
    transform: "scale(.0625 .04762)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bz",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dC",
    transform: "scale(.0069 .01333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bB",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dD",
    transform: "scale(.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bD",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dE",
    transform: "scale(.125 .1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bF",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dF",
    transform: "scale(.03571 .07143)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bH",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dG",
    transform: "scale(.04348 .0909)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bJ",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dH",
    transform: "scale(.00629 .00952)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bL",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dI",
    transform: "scale(.00505 .01163)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bN",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dJ",
    transform: "scale(.02439 .0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bP",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dK",
    transform: "scale(.00444 .007)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bR",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dL",
    transform: "scale(.25 .2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bV",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dM",
    transform: "scale(.11111 .125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bX",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dN",
    transform: "scale(.007 .03846)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bZ",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dO",
    transform: "scale(.25 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cb",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dP",
    transform: "scale(.00813 .04762)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cd",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dQ",
    transform: "scale(.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cf",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dR",
    transform: "scale(.08333 .16667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ch",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dS",
    transform: "scale(.0091 .0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cj",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dT",
    transform: "scale(.125 .2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cl",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dU",
    transform: "scale(.0164 .11111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cn",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dV",
    transform: "scale(.00847 .04167)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cp",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dW",
    transform: "scale(.0068 .04)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cr",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dX",
    transform: "scale(.0204 .14286)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ct",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dY",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cv",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dZ",
    transform: "scale(.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cx",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea",
    transform: "scale(.0196 .25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cz",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eb",
    transform: "scale(.00599 .0303)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cB",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ec",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "p",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cH",
    transform: "scale(.2 .04167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "eb",
    width: 167,
    height: 33,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "ea",
    width: 51,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAECAYAAAAj3gc/AAAABHNCSVQICAgIfAhkiAAAAEdJREFUKJFj9M4X/s8AB0hMQgCfLvKMIQv8RzKAhXTdBBxCqeuIdQYWe4j3zH+8XLp5goEBu0cYGIj1DJWSFKUAlycgkgwMAP/bGMPz59RlAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "ec",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABlJREFUCJljbO+c/p8BCpgYkACc8///fwYAaYMFqYbiZ5QAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dZ",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAAClJREFUCJljNDa3+c/AwMDAwAChmJA5DAwMDCwwDkyIBSHHwMDw/z8DAB2aCKqFum94AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dY",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAACRJREFUCJljtHfy/M/AwMDAwPCfgYWB4T8DlMfABGMwMDAwAACUgQXNetH1YAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dX",
    width: 49,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAHCAYAAAChv6WsAAAABHNCSVQICAgIfAhkiAAAAF1JREFUOI1jdM0U+M9ADPj/nwGnQhwSRBmMTxFxLmNgIU4ZDvNo5XgSAUFPkOJ4AlJEKiAd4PTEf1ycQRL6yADDE0PJ8TCA4on/GAzcYDA4HgZYMOwaYh5gYGBgAADk8yK2i5Y8YQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dW",
    width: 147,
    height: 25,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAAAZCAYAAAA1zhyrAAAABHNCSVQICAgIfAhkiAAABKpJREFUaIHtWluO20AMUwGfvegJetyoH4k9epCS7HW6+5FFAaeKLZMcaqQk/vX7z1+V//CnqvAoorK/VFF5/nseX69EVOXxOrocIiKPGPM5Xhnc64RB1310nXy8VrWxR7qWchSPyebaU+bYOiauMJZ54Vjm6HmhGFszvJ6bvPkvm8aYJxgACfs0kY8dwkbTkLzLUExQIDo10YodS4AKJPCfcD2WKuJMfI5bF8WT89IioiZqOIb1fJuZqpvmmELgDyi2ijyQeGeEtYuSBfVYLpoImabgGs3jcRq8hCsstpi3wvIFE+0YbjcTbF8IiCUZAOOWNjSRvd/QROja3UQxnz9naKLiWvheZ6KKY2MizPW4A2xfEnJEE+2xW83EgXChrNi0pTVzUYohDGC771vaMiyr1DwXZZxtEaGYe+968SwvzIwFObat+hm7xUyTuSi/NzCRaN6NyIJVLW2CxZtoxZiJzB0HVZznl1FLQ4VCTEmxtCZqOJL1ROd8yUyn56KFfrW0qYkOHaLo3ERLeyCoE+b+uQhdiw0ATES4IhOlvFMsZ03UcBW9aKZqS6TVGGKTuciSaLd2FEML5s4TYR/1YasWg3NQKHDhy1YtBOc5E3GuzFgnTWQwWCynzVR+T0SFGrQ0MhfRvEMsXOz5bmSaE36PiK3rosZYx60vFc8dLW00jAedIp+xma5+1G9NJMrnIiIs2nkWvGK7P2kia6NyHpqaKPE5bl0WYMw7wTI1EVrPcrZ0mDzO1kxjEwXi9to4Fx3/+4aP+qdNZBcX8Zi0NmQixLXSMnCsWtqtc5HBICFvxFmaadRbgyj2JtVclGKViRCGquqtkCrSzUUJiwQ+geu0iHCrFoEc0c5Dd+CKKzMW17I1UcXR5IBmGn00LCqqnYvStSQvEhZg4WL/gJ9AgokQ/4mx7pyL4HoCrp4X4B0K0Jnpq3ORyA/4CeQrJkKmKbhGYT1OjbcGRZQXJ5mzwDI1EVrPiqvXH+O0yu25tu6mSEhUeQ9EZmoii2FoInRtmosAzjvnosQ1mshyrTgic1LTxCPQ/ayJDAYJeSlXyZi20VZYVJSbi6wYb3k0pBL7jkdDarGxsCyGTDQrHs8LxdiaIbMxrn7niVho/qCdPW7QvS2Ab/gJpDXRih1LUO1GY7GBkS+0NM61KCJqooYjW0/A1WMCvEkBunV9vd5USUsLRwvm2+cikdzSpiZCpim4RmGpiQhXvjg1R2yYhmM0UcHVJKx3YGQiwnVLJAri73s0pFkwJ97n0ZDEcWIigyGaCPMPx5Wcct2YUBbAz3s0ZMVGYqjk96oisq+jGZwprhfPvKX1hqq/1/I61XywdtONAsxMAxOJfh4NAWKnfMA8Pdf9vIaju7Y+x/PCOK1y7aZAtHvOTDbh6/h5NASYiHDli4M5lljOmqjhGltaayJ7vwnXJZWZmV4n1D+BZBLt1o5iaMGskCrynkdDCkHRjro0rTk2O1vZvkCs/JoGtC/ENRoa5g8mGq0nMNEe254Xfx4NwcY6bn2peO74qD8axoNO5Q55oaXhApAQU9keakQPxD+PhiD+2YBnsExNlK+t83teGKdVbrKuSLsKyz/gkAyghjd/UgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dV",
    width: 118,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHYAAAAYCAYAAAAvWQk7AAAABHNCSVQICAgIfAhkiAAAA89JREFUaIHVWW1ynTAMVGZy/zu0J8gJrf7Asj68svUI70EzmYHIILRaa7eUrz9/f5ge/MPEdPzqkXvF3E9kjcYa9z/liGIM86O8rAs+B6jlWGMTY2r2PqmljcL0eZIDYaxi7effxf5+/CcCGO2KoMKRyDZjZHJkxI2i4Wwty+FjngSmxhof11YJRQQmhGpbmFo/Po5Y18wVoXJNPx4HD9LHioSae6qE6r1KoiOT+zWxpiqhCA/A2gzWRxE7GmwKzGTXNeC4AO7gCslTjOYGziTLuRAq9QZCiZZTmkvsmmRHqIs1IqJnEFvx0ZUUuYm2MTSlq43i8r3qo5LrhOyma2sfdYTKs7vS3UpsWXaXkuTXUkJHOFur+qgUGGT3Yh9F90r+jNAxFHQTsa7R0pyi7MBYVWINkXuJJYIbJRIq1w3ZPUkoxDNjbQ4rKy6jXLd47DU+imKY5DSvjS/kMcru7KP9voKPwrXdhu7nyEdFdtFG/hixKx9FUnSXj/qYJeEaHy1j7ecrH0UqwMRE7QPEln3UAtj46ATEkbZaq/mo3vMmH4UYx9NHLX5jzj46YWxy9Rul2DUJ/OOjPJGvSqwhciWBV/ooyr8nNMcafVTy8gpj87neQuxKdu/yUSS7V/ooyvtuH5Up1c3Y6+OLJzYCsITCaa3uZDSRCKQhtCq7T/pvQK2TSz7aO2zw60a5hFjXTB6PW+/SxEddLCWtMJlnfVRyiZ8lXrglFGL0hBKB15edj3LEyNNGYbqA2PFQU+Byp1VIhrENyaCBV/goyruXWBTzWJvDimV32rRNcVjZjRiZf0EsanTmoznIHDiU3cRHM3CuKcFHicLnNDne6KPpMBgf1Z5oXrShXya2LLvh6AtAwDcTCddqsjv56Kj/BKGIwBXWnn/rowhr4qM2b5xgOZaJnQmtTCQG6WNFQm2jL/BRJLsf9VFXS8DIEeOe0JijROxosCkwk13XAEcCiq1JnmKo+UCSVHaNqkBCR2EFH0Wx9YauvL5MGzl5fcGEotiRd0ksmqbJuyy4KqEgb9a8leziWiwxz/uc5vJbjJvXl3xD46mFxM6yG0hKwPkCEHBA6AhnazXZVX8LsnuGUH3AhBXdK/krn9MmjL/wUVhLL90R6xq9SLidyFcl1hC5l9jYPLk3ECrXDdnNCJ3r3G5agDX/nJZg5IhnTyjuk8b0Dc14rBaiBU6SNBF0nuQ0L2w+kF1pBgmRYTqllod9TpMp1c0o7JyXXdbHDKzfaHIUL5jWKqEgLwRpCkQTqdzamAX+f31O6x02+IEyLWrZESo5/gE/dKQNsu3uoAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dU",
    width: 61,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAJCAYAAACBiSRSAAAABHNCSVQICAgIfAhkiAAAAQpJREFUSInFU1sOwyAM8yTuPO0Au3a9Dx5xAlTpOmk/gEJI7GA/nq83AQAgSID93Hbd6qHdjZjlk6t4LapvqEnkyNWybHG6VPqAdpcG1BtfHgBRXAMHh4GsFvdkIymtpIPwZPtCH2p4PFkAOEJvy12SncpbrJA8IWsv5wGLMnZkR7k8WW2fJWs1ggrpYx1HOXxGTsonZPXXGdEmpcxRYCfleWA7KdPhqODKf30bwPYBXPWtwZ4GYJ9h78o/ffuNlLO+jWT1WAzKD307Lm+SXUp57dteK0pZU5pWUYAj7VsDct+3NoCLUt741iERKcPd1bUwkp1xI+fbvmR8C6x+97JvW2zlW49RvpzABwPkxtjGrgW2AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dT",
    width: 8,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAABHNCSVQICAgIfAhkiAAAAEFJREFUCJltjTEOwDAIAy8SL62Usf/fch2AJkPYjO3zeOYrgIgKUpc6rM/NFAjMNsUBWPoH4zRtUiI3IZEd2XMiH90RNw/ZHL9bAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dS",
    width: 110,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAAQCAYAAAD3c0pKAAAABHNCSVQICAgIfAhkiAAAAmVJREFUWIXFWFtuAyEMpFLu/131BD3luh/B4MfYmIRtokpbmcXMeLBHydf3zy+1f/gQ8THUnv/yE8WoPR+k9tq1Hu1/4jnC0VqUQ8f4PMYw1/sa+Xcw14kBcUV7FRbA9bGs+JufSSIjRg4oAq9yGFFQjExRfCFQzO+VgrXWGl1BsauCQT51rrcLlxIKBbAiohgmFuYtYrHd9swhYpfctxIPdVEsYniRRA4SOW4RbnssVgVDHbUQDHXUhOfHonyOUlF/NxEMXoQq1wAn87A1PN5xZcEMULkXjhMk2OAWrdV8zHblXD/kY5DjON3XAfDh428Zlet5f8MINEWPsJz0Mch1Kdg+V7JcJYbrgHBZl33Kx9BYLPvYbpfd6GOO48XZ3hDuXR+bjw0fC7qtOhZjTIfGYsY1xYl9TArGODm2LdxJH1OxUJRCZx3wMY1vUzDIUQu24solcRfWjvGeY0u4HWLxWHyNGL9sxSuJ2MgI1mOX5RFzjAVDsRpXslwllstPCpm3JNyOj8UkEmJO7EBEs1cTAyIqvCb2KR9DNZQchY/Nmsy8jCEV7lUf02QRsUVHwbXaWIx8Ro7Fkz6mcqQ4fadawfpbSjCXt+eBwpW/VBqgiISOFQWT5x3wsdbaPT9TveNj/C5fJok3EYy5OuFKP+EYUF5EFMuJuRjCAEaGJgbG6BBsACv4GIotLmzAlQAv2WXjjSFKbAUyNoSr+JhfKwiGuiwoTjYWS1hGjhfGYrgWcA1wju6yNZQcg7FoL2Xm2Y9tH+uJ9AGIGBBshKO12li0Ysz1FwRDHZV150KwIRziuuljGZY/0JgUZ3ucBGoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cG",
    width: 165,
    height: 103,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cH",
    width: 5,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAYCAYAAAAyJzegAAAABHNCSVQICAgIfAhkiAAAAF1JREFUGJWNkDEOgDAMA43kj3Zg5P+jGRpBYhrUjhc7OfUY5yXYIyDIMBVEFToCqAyiRazrn+Pgg9KQkOoZqa3LjZrkDLr8r9LWzhA0pS15rOVLt9mJ9Mk5+ybT7Aa0jEdL96ehAQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cI",
    width: 13,
    height: 25,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAZCAYAAADqrKTxAAAABHNCSVQICAgIfAhkiAAAAG5JREFUOI1jnLTb8T8DBsAihARYCCnAoQkfwG4gWTYxkayDgaDz0MB/bJqIdCkLGV4i0XlQG1iwCeLTANX0H0OQEBgk8YTLDSyEHIdNngWfibgAExlxS7MEi+kWEuOJ5GREtk0QQFZAUDn08LgaAJ95GsuNVdIHAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cJ",
    width: 189,
    height: 95,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cK",
    width: 14,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAABHNCSVQICAgIfAhkiAAAAFBJREFUKJGVj9sNACAIAzFhRnd0GjcSf1FPU/vF62haWq9hm+LWpdL3MyBRrhwxqAieM4ip12ECh2SewD8AHF86Q/ptITgGYq9XYWZOCRX/CbkgFuD8iHNaAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cL",
    width: 8,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAABHNCSVQICAgIfAhkiAAAADlJREFUGJVjnHXA/z8DCviPQrMwMPxjwAdYsAkiG8nyH5sKkhRgNRdJkIXhP34zkByJXSELLgkYAABz/w69S1YU2wAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cM",
    width: 174,
    height: 68,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cN",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAACNJREFUCJlj7OqZ+Z8BCbD8Z0DhM7Aw/GdgQBZkQlHx/z8DAIz/C7FGl5TrAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cO",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABpJREFUCJlj7OqZ+Z8BClj+M8DZDCz//yM4ALKyB7Mkz6JFAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cP",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAAChJREFUCJlVisEJADAMhCzc7IUOkHnNq7Txp7j2Kbko0ecA4QsCkXk0HMcMp4QOFgIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cQ",
    width: 9,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAABHNCSVQICAgIfAhkiAAAAFFJREFUGJV9kEEOgEAIA8eE55v4AP+69STpbl05ETqkheO8buElEPOopHng+gsnFLwoATS4GrXdsFVZLofGupsZC8u0S1ct/MAf1ynatouPWj3XxjGquh86qQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cR",
    width: 10,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAABHNCSVQICAgIfAhkiAAAAFdJREFUGJWNkNENgEAIQ2vS/Scwt4A70vvxTiCg8kGg4UHDcY5LKEKIMrMACEuSy5TMtX1wD9gzWkGUJVk1QKniMwzQm3/zyrCwOfvv9F2y3/L58OBgAxM4cjPa7XeRsAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cS",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAAB5JREFUCJlj7O6b9Z8BClgY/jMw/GeA8Fn+w5n/GQDCNwm1oX0qewAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cT",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAAChJREFUCJlj7Omf/Z8BCbD8/4/CZ2Bh+M/A8J/hP5IKOPc/A8N/BgYAz64NuPhXseUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cU",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj7Omf/Z8BClj+/4ezUTkAy50Iuaqm8mMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cV",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAACNJREFUCJljnDNv9X8GKGD5zwBnM7D8//+PgYGBgeE/AwMDAL5yCOf3zIHIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cW",
    width: 7,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAYAAACJmvbYAAAABHNCSVQICAgIfAhkiAAAADVJREFUCJltizEKACAMxCL0/4P4AT9qHApFxQzhhlzrYyoAaY4dy8UPkVDfQxGY1Y/7WVl6A3jNF8HW4n3EAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cX",
    width: 4,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAACJJREFUCJlj7Js45z8DFPxnYGBgQfAgLJb//+FCDAwMDAwAJywJvdXAbk8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "cY",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAACZJREFUCJktx7EJADAMBLEL/P4YMkA29blw1OnUfaoApG2WBMXfATrKDL9xYqj4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "cZ",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABtJREFUCJljnDhlwX8GKGD5/x/ORnD+M/xnAADTwgrGjXfcQAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "da",
    width: 3,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAACJJREFUCJljnDR14X8GBgaG/wz/GVj+///PAAOYnP8MEAEAw0YPyIPcleIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "db",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJljnDRt4X8GKGBh+M/A8B9CMLD8/w+XYAAA1lQJywXpdGAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dc",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAAB5JREFUCJljnDJt8X8GKGD5x/CPAc75//8/AwNUDgC90QjOkcpBWAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dd",
    width: 75,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAPCAYAAACshzKQAAAABHNCSVQICAgIfAhkiAAAANhJREFUWIXtlUsOwzAIBV8lrt9FTtFbli4SxQ3GwTjxr2qWMGBrZMjj9VwY/w+ArYEa3GKQz/kmFPyHZBUMiFlyBCaTdf11WFC6hEeT1VMGAP7K9h/DzjLAASjofbOsGnsjhs5G5YoMiyqQ1XdvHJI3CVGJ6Bx1Z809KtmUDGxC9G5rlMzDZpUhgxwCMWudscvKvU+tUWkhwzonUSHCFLjB9waw376WjEDqPOlT2ndU/DL0vFeG1ZXwzikcZ2/IkLqnC2XoyUCQyPgbN94bK+n7YydpVrInrT9K4qNc7fRv1QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "de",
    width: 146,
    height: 54,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAAA2CAYAAAAs9sB2AAAABHNCSVQICAgIfAhkiAAABW1JREFUeJztW1uWrCoM9azF/Gdz7wDOwMz5sEoJeSIPoYSPrjKEJMKWvbG7//z3/1/YVnttExcf0n5iQD2hZlGrjdk0sIBuYMYD67uA9AOtdFcRgZJ08n5HW0CaoNWiH9oJbqAAbz7bAtIgjV0fFhcW/XiBIoxSFXPkn/gtIHVqzXQK/WBHAW/mC/p+s7bC6GoBqVIbQaeU7ipSXFQR2vCuiwUkZ5tBp5AsTr/4Co9hahM4eAEpaj2OyeX0k2TJoB9aDr0PPt71cHDd8DYgZQGFGVBKP611CjsGPMCzgUKN+L5+Cki/RT/5OuX0kcAi3LYHKHJpx8V0QDIeKGysAhRh1EM6RY4pA+WwcdurZ7fkbyC1DgekOXRKMqZIp9AArejHccFl5GtMPrsDqZR+SnUKunpKp7C5WwGFNTBjdKBcF/wkVwdSKVBYn+/37kCRY/fWKWRMLv0osfB8qVv3x0yf7ltAGoZ+cgCQuat00SlJoCKgKLFygXJ05QBKOP43Awr9YEc55pCOqU0/ElA+Hz2AQt089EN3Cz6uB1BfL3ORt8Ddj0U/6ibZnX5kSJboFK67xjFZd2lEPyZQGCcROwm0Pl8CgLWrPA0UOfbd1/lZ9FNTpyTxetOPXlhsBn39gM5TAFS4BhRs8e3MHrpg/KIv6hM7OP08ChTVZADlY2fnKhnz9QkAu5i5Ff2IjPOCYzJ260A/lYBitQDSijBRZzgm69i4DxT0/Q5QRL88oFzmfPqR0zjAcs4LsHMS0CKUAoUB5Yiv83+FfkBbsNxdBT/x/LwkfrE9gFBtbFafWAko3Fi2TL1AD1Com0E/3FZYQD93gSKVEjvWox9AE5ALFKOAg9oePSbrXCSMaUQ/4szVOyanjjV1ikU/1M/5aDqmKOy7sG1k04+8uNn0012nKLuKus4FOiUZU0OnUL98oKhjlLhh2/lbWMfkJPIP0I85piBu2JGxDVDiPhqqNv3kAYUrI3V8EihaadlASWKXx70s4VT+o9CPCRTGqRX9kDRz048nmAfC5KS+pcd/Z1Hd6acEKNvW6JhM9798+vEuaG5cOZh7r/OwUGQOwBQmAkWNWQAU1fRenaLH7gsUvcEW9gfpB8hPIXZVoGw++hlUp9BLP/1YafQGKG66H5/UNuzr/GTM0ikkhZ4pEyhxbEreUn7A1HaY2tDPSK/zjQLsMYPqFL2VAEXwi0wBtt3hG/2UCq9KP4C4rjtQ3LG9cQvoxw2Uy9kDFFd+smmC6Ir+Huk2/UgJtfbg6/zSuPSyAChGF+cIpKyb+VmTDJYrLu1E75Gm0CmkFit/O/oZTad4ct8FihWcfSE5Bf1MekxO4/qBIvjdAMoR27nGYi24EbGdZDsDeoBC+qSe2XSK0cU5PqFTcNz8XcUzRHoN9Dn+v+WYXA8ocexRdIrgKdQiebsXD8U9fmk7sU5J0sh+k+mUI3Zd+iH51Rq8cY/OhNqWTrmVvxNQaC3SCLd2cMT1bQZhA0Na/8Ax2bqDqemnIlD0cPrcsb+0NQMV6RQl02T00wooKL9aQx79qKEKGSGwKSajn5mOySS/WoOX1toDBbtQH+b4X++p1htHP0unmD5GVtbqlA4WWLTRIV1QK9ldnRJZeO+ZdYpaQz+dYvrpg4zccids3I60dArNr9Ywjk7xAEXN4iUajtpyJmgW+hlXp8i92UBRiskFCulyxcVXYdugGVAO0yD08wKdonWWAuW4lD3CDtIkjg8UlF+toT39jKBTrLh0eDp3Dq0mKCFTI72PfubVKdSPmztjDkQ4UO84pPB/bUz8dUzmewbSKemu4gHKZVLyieC+Ok6x/b5j8pg6hQ7PpB9VkQi7igMoYtBPgH8mYK2/UZ79pgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "df",
    width: 34,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAABHNCSVQICAgIfAhkiAAAAXZJREFUSInNl8t2wyAMRKc5/GwX3fX7M1mQGD1GQBqnJ2xiB0lzJQG2v75/fokwePymqWw0s5u685gngHbdCLILlIRWcckBMqiey2q/WvaCye6B0h5U5wjNxnX4EK4tANCkoBJaitFfKUd6dcPTW7OX1UzImgW7GPjuHDUbC4qiY4VQMqp9qP3yGtkSCrNVK90/hK1+SLterPtC2ofhXu5O043mMJdiz7aFbkUSKkK3ab4gZ7aFEiSr9Du9fbd7YRpQncTm9HSewanV26MG8sWvE6Epis5olKqlukmX4vRlLHMW0JV42Iyd1GKJtFO2qY8Zm5iqF31cdquwfedL1MIVnR/BV9U6IPpoKdPEohulq0XLkv3E0+4AqZ++4W65kdiFJiAVRAdZhHeOnL0czCB0O+zYa80fs9yFQF+scuZciFWMfo68APES5IhBSJC9hXkmBABcPgECcBX5D4j7MSicL58AAYQXo3edESsIwH1g1UbvhgCAG1hWiDlHqoAIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dg",
    width: 28,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAGCAYAAADQQP5pAAAABHNCSVQICAgIfAhkiAAAAH9JREFUKJGFkjsOwCAMQ10p1+3UrYfndaCF/KQyxcR2PnCc143WSeELh7/3PDYk5SmaybNJdsrsWXQsy1x3Axx0JCSDvhjLuClI5FGIdSNfGcPvznWyQ59LRsRZwkx5WUz9O+Hfm0jSiAaj4TAibPo05ZWymmmkO0HzUbo49aAHhLxpA7M9WLoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dh",
    width: 31,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAECAYAAAB2v+RhAAAABHNCSVQICAgIfAhkiAAAAFhJREFUGJWtkEsOgDAIRJ+9onfzQB6M58KW+Iu1iSxImIFhYFrWWZUQVAzJOsSKRzQeNE58JG72xFGLZ60CgC1JP772eC8vcEmkq/mjuf0F9fLXuZGlY+Y2gKdpOApBEF8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "di",
    width: 69,
    height: 39,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAnCAYAAABZsYV4AAAABHNCSVQICAgIfAhkiAAAAptJREFUaIHlmktuwzAMRKeA778ueoKe0tOFQ4mkfv7IipxmI0gxKfGZpAZBvr5/folJPiSzI0CQAEEgjEzWt3nu2cYoe3GbLaMDL30siC0ws4546G30cwQgkICNbWm0PgDOAeUuIBKmB8S4gQUyS6ZYEB6IOqx8XwOi4J4FQq7vhXIaSJhbIL48xJfpG+IzO1/flym+gbbHNQPoHBBfqiCwYgPy+mI8lORGKQCKwa0pKAiQEzcM6kA4GsoxILnSinZXrty4jwBRzZkDy2cWDZIDEkrwtc8QKCUg79AgG59Mj1K+b4cyWpTtuXJLQMT2VigzapAWkFt7yqwaxALx5bytd4dyXIPcBURsgNVducFGfBownaE8QYO0gAAdy6cLEKoMOArE3zABCEPvMc1a2YZ1dMyUmTVICYh/IRFQByhHgVy9cq2v6CPNtEzgO4AQF8tnmh+GqjeMjHLW0nqEexrKUzVIDYic/RSU3kB8NnhAPTVIrtw1kMM9ZR4NUgKibMSnA9ACAh7oKXuBxODm1CAtILsz5ZM0SATiSi3EtQPKEzVICQidL4DgSjtvlc81IK5/qCBeHipg3A2TZFpaumKbrB8EUs2UT9UguqflgBQzpQ6E6eFqQFwdQxgpQCM0SAmIL3MgA+VWUaZ8mb7hbO28rwZpATG3z/waRB1efDoAe4D48tfPyr7LOSDP1SAtICCx/DcNkmSeA5Jkyn/QID67PRCTKUeBUL8FFURMz9LoDuEzTQ6dAeKDugMIQSzxQR+UfdA76CvKxmkQY5sBAgKLBZKruQoQV8ey08waJNrInunLVD2lHxDTN5ytnY/XIC0gr0wp1J4AUTU4RINcALL3yrWAUlvVU2Ss/UHGgqiOLgjZ/N0apAwoZvsf2UA0wxJykiwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dj",
    width: 13,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAABHNCSVQICAgIfAhkiAAAAFVJREFUKJGVjzkOACAIBNHwOxsb//+UtcGIsJpIxbETx9L6gEAEchZIt0qBvETIIsC6mQynrRlpkokpMpkeUXzA5E8XTZdTfuDg90v+Wn8Bp/cOx8QEP8sy4upaN88AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dk",
    width: 13,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAABHNCSVQICAgIfAhkiAAAAElJREFUKJGtkMsNwCAMxUyn6TaMw/Zxr4Aon6q5RErk5ygpl9sIUFEwuq6E7f7iQw0hF4N9UwX+d14XvA/NkqbQm21pGoHnjxAeVFwn1RpqQW8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dl",
    width: 10,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAATCAYAAACp65zuAAAABHNCSVQICAgIfAhkiAAAAFBJREFUKJFjdHT1/s9ABGAiRhHRCv8ToxDmLrwKkR2PU+F/NB4LfgUIESZiFKEoxKeIgYEBYjW6e7ABJmIUoViNTxGSQsLRzUSMIjSrh75CAGfqE+hAInJvAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dm",
    width: 111,
    height: 68,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dn",
    width: 7,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAYAAAD+WDajAAAABHNCSVQICAgIfAhkiAAAAB5JREFUGJVjdPMO+P+fATtgwiXBwMDAwIRHbohJAgDTEAPw5aMzSAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "do",
    width: 6,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAABHNCSVQICAgIfAhkiAAAADVJREFUCJmNzbEJACAUA9HTVRzFady//2dhJRgw7eNIm2soYEkJKhZ0wg6YIBaP6i5M8POxAX/JD82bSTkIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dp",
    width: 88,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAATCAYAAAAUCsqbAAAABHNCSVQICAgIfAhkiAAAAhRJREFUWIXVl0FyBCEIRUmVt05VDpBLk8WIwgfUzDSdySaMliA++bT5+Pz6ZmKi/oeIiJj5Me6/+w/iYOws8VgzbTYPduTAxCOnuQb3M/PdF2PFFnMWP1a5Wiu+Y+zyR5/HfEvhynwQSJZb2GpN6ruHa8dXwk0KwhRGZm2hjL3l/AvftrzpC+DubzyYl7iS7AqMgS0B6+BiYcjaCDYx2QoO4bokELaX0Z1wMXfx2rYyPNcTLW4Hl9MKzuAubhxh7+WEsANbDLeixZEZc1TBJzf8GtwJ5ECaG6hxYcwLymBfClfFwsJoT8kpApHO3wR3oUKJFX9P8haXW9/i9EXpnNu1cA9lFMJWFU9yJ+x8q+Gi+jxU3+L0/q6CNdz737jTF/ezsPshjmBjzhmgYrh93CxccYhL/33fuAncpfqwMCzckzfuDi4TUauB63vUf3jjpnCDWA4uKroPWgwkkA3A3cvpdbhYpeL1Lm/cHVwmpvYbuE4i2Y072IG9Fe4zKlR2SluNtboEB+RNRC2TQCnckegaKib7J2/cBC7mPvACn/GRW4JI50FORjY1cO14xqp+465Ul8El6h+5M7iHNx3CBjlJguB7ZEvg4vl9LK2ctB2pPUaLsItw81q4AxH7WLHFg2WA8hZ3OVzNL8i5XdWjbn/jHsCtfuPu4BL3/+SehouVsEpiCVtKZwN1Ic1SuKjokcO+MH4AZvOFx1c6j/sAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dq",
    width: 10,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAABHNCSVQICAgIfAhkiAAAAElJREFUGJWN0TEKACAMQ9GveC8nF+9/nzoIolZLOmR6hNKm2rohTFaQDk2BNiOGtiKAGwIob+QP4RsfyMMPOmGAAMq9dNAofZAB4IIT119YxroAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dr",
    width: 6,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAABHNCSVQICAgIfAhkiAAAADlJREFUCJmNzMEJACAQA8H1KrERe7H/Ilxfwh2ImF8IkzZmV0FEQcUFwYmURGneBiuqIqmPq6dIaAMVzRS4JW1K+gAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "ds",
    width: 117,
    height: 66,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dt",
    width: 12,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAXCAYAAAA/ZK6/AAAABHNCSVQICAgIfAhkiAAAAIhJREFUOI3dUjsWgDAIi75c0MnJ+x8jDtonFKh1laGPXyAFlm0/hEpk1ctgc+pRBiJQ6jPktS6cADI6z0toxELBpGKpwuw+7UPR2TzMgjZF3gSRjDOj0iYWp/QCpPqeGTkTIiD4JsNV14urityU5ugktzSmA9ixuqo1kHNnbTtMJjZZv6X/A3ACtnpVARxHs9UAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "du",
    width: 5,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljtEpQ+M+ABpjQBQZeEAAiCQHJuLzRMwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dv",
    width: 9,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAMCAYAAACwXJejAAAABHNCSVQICAgIfAhkiAAAACdJREFUGJVjLFsg958BCuAMNMCCTxIGmAgpYGBgYGAiQs2oIiIVAQCR6AVKILopQwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dw",
    width: 194,
    height: 111,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAABvCAYAAAC+Yx8BAAAABHNCSVQICAgIfAhkiAAAFWJJREFUeJztXduS6zgO01b527f2C/Z3PQ9xJBEEqKtz6UkeOm6IIiEbUExPps9//vu//5/pptd5stRn8jDDHvgjD8HKocBwhk106oMrj0101jFnjQcYfZ2O42kn6xwnoKdhhQn8mIp3sSdOSamDI4ul83PZBsbqnIQnwXo184w90g0vZYBn0RgrY3Ix+YBhpCoTtTIAxJsjJuARAwDHaQMojIo6NQ2zaoASz4xxhwEKgBjTTD6iHB+/bzXCPQa4MDtVYFBhlwGgBhoA2DAm0waAqQOibseWt4aAmwaw8d0mEgZg15ZdD9yk5NULDPB8bTPC99wGMXMwqQQCVqJmbKJYtjtWfKYNcMUT2Wph5RJ9HJcMgHmDTaJpAMXF/Bqt8XG8bISRT4EpA+SDVQPYiTp+vwFcfLDD3tYHOFqTAs7xjfm5XgNjdYYNUGHm14bJqzzTRnjdbRBbIKn6oj4AGDIm4Q4n5//6AHL62Vrn+wBSPKtr2Ai7DMDi/XXp6AMg0bQBoMbYp0BHLBNHxWdO1CVexZa3SQGnRA3zlj5AcbE/Ko7CAMmvf8gIvz6AvbwyQyEA970GsIHU8kLA39MHVJjJq0Uejz1+6zLC+qdAYzH5gGE4wybysWzMnVaXf8oAUbwSx8WnLeqTveVYhwUiqqYgYcnx/Y9DxzRTOOJaMA/XR2iEP/s41F03gdHXmgFgKjdFxWfEAOVt1QAsx7wB8NoyA0DFW/oAN1rNkUZoO0thHfGG12Qf4BO1DQA1fn2Ao2PiR/oAgwXXll0PxMYehwoDJL5+NMDzyBnh1wewl1dm16fAhAFYPJGtFlZKQ58CW/sAFUfEHhugwgyNWOQ2T6c+Liwb4VP6AEbax7IxKol1A0TxShwXH3+Kfo9DGXZnH1BSxJo5fn0Ae60ZAKZqUU8YoLw1BNw0gI3vfpokDMCuLbseiImrN2SAkmfcAM8j0iMIhwoD+LGK0hlhOEOR9pPkAiMBK1EzJlEsE0fFZ0TUfu/o+cRoGCDgeE8f4DF2PRB7ZR/AMDw66tDP6wMI5U/rAy5OIwZwY92fGBMCNvGN+blsAxNGGTNAhZlfY5HbPPQMez11aOYICQoT3NEHwFQzKTSMEvCIAYDjrw8QWNMABUBs1+PQlT4g0szxlj6AEZwxANTY2gdcY7fcBn1YH+ByCAOwa8uuBwpOXr0BAxT+iwZwKR66btwalVnv7gOgAhdwJGrM9A4DXPFEtlpYuUQfx62PQ9U5YuIm2FgfAAUHDRBiygAVdkwboFTGQ5LFJvLnocfR+w3g4pU4Lj5tUZ/sLcc6LBBRNSWlTo6vvQ3qMUCFmV8bJm8ZCYqMaAYN8MQOZYL2bRBbIM5IeFb0jpAPqCS4gCNR+6rhDifni08BIsM/ZQC83o6/W+vrvxaxQzPPdR4IQt6EJ0RjmEWRdnR1bCRgJWrGJIpl4qj4zIm6xKvY8jYp4JT4jtlrIsSCa8uuB2LxbVCnARJf/7ABXAr+KVBTPupZf7kPcPEbDcDiiWy1sFKSAv6ePqDCTN5I5GMGCLFJAzxfpEeAi34qDGdYgj52wNGrBojilTguPg79F9wGjT0ObRggHyBHXAvm6dRH121QwwAwdibXI0zeBv36AI9BIEbMGYDlmDcAXltmAKioDW1/VBy5AUoepp15zaTU+5jfnhN7a2Qrtw0gSTu6OjYSsBI1YxLFMnFUfEZE7c9xj2FQHB5THO/pAzzGrgdiY49DhQESX/+wAVyK/tsgpo/DJ2CmAMKStJ+EC4QKCwa4At2aGuKo+IwYoDteCSuloU+BrX2AiiNijw1QYYZGLHKbp1MfN/QBMGLOyVGSwIVVJrihD8gERwwAHH99gMCaBigAYnf2ASXFPs1EGm6dk+O5oBEDFIzSvQ5mFxOZYM0AMFWLesIA5a0h4KYBbHz30yRhAHZt3ZVBAytD2x8VR26AkmfRAC7FXB9QOPnzRG6NXIwg7SfJBUYCjkj7FehYJo6Kz4io/TmefRzax/H2PsDSTXytp+Zifq05CgMkvn7UB8OaBlCYL0fW76/HcxL9L8ttAxDKn9YHXJxGDODGbu4DSnxjfi7bt7tt7QPyQcPkJg89w15Pu/oAGOs5J1jR/z/LiqAyAMSbIybgEQPYhPMGUBgVdWoa5g4DKGyPASxQ82cGyEeUY2QAEm8HlzVToa7cqAHqo8PHsJPBJw/dBrEF0lfDANfYLbdBu/qAgOPqbdC2PkBxsT8qjtwAJc+iAVyKjX1AIST5HCHBjgWWiEDAEWm/AkACIQD3aQNc8US2Wli5xAsMgHmDXXDMABVm8kZrHDNAiCkDKMyXoxuDx7QBnr8f649DX2MAmaPrNuhkbznWYYGIqikpdXJ87W3QhAHyAXLEtWCeHn0wbMIAMDbTB5Qxf5XsrdHoApWAI1HDCLJcfRxKZPhmA7Ac8wbA3dHxd2vd1weU9OSsLfQBnuOF+cnDBmB8mA4OO29gMYqgIm1eHbFMHBWfOVGXeBVb3lAcHlMc73kc+kf7AIUBvqMPYJp5vg56QkigSTVtgCvQ8T9heI8BWDyRrRZWSlLAvz5gXjMjBoCRcPNwW1iHAZ6vw59CG2yOVg0QxStxXHwc+pG3QWcTUzvZ7OPQbgPkA+SIa8E8seBHNNM0AIyt3gYxzTjowg+cTFMzh0au9aWmDQBTtagnDFDeVg3Ql+POPkAa2v6oOHIDlDw7DfDA3t0HuOoVfsgFRgJWpG2ZdiwTR8VnRNTM/dT/wgClRB/He/oAj7HrgVjcByBHYYDE14/6YFikmbwihgF+dx8Q8SePT1cNkFcASEMcFbkRA3THK2GlNPQp0G2AXLaBCaOMGaDCDI1Y5DYPPcNe8F/cB0QGPhCgBEcMAKx+fYDAmgYoAGK7Hofe0wd4zXjxQizgd98GsU3mUI7+yD7gehuJLW8NATcNYON39wGQvZprEnFD2x8VR26AkmfRAC7FZB+QOd1gABhTej9QWau3QZ/XB8AREYzieHsfYOkmvtZTczG/1hyFARJfP4olxJQBFObLkfX763GPAXJBF310XzBWqrFAmQMFvKsPcLQmBGziG/Nzvb7dbWsfkA8aJm8ZCYpsNQCMTfcBF6dlAxCuz/Ajk4lE7UuNLbAi78346wP8Wr+xD8ioK/eOPqDM0Qaol3D0N8MNA+TE3ACeS6+o27HlbVLAKfEds9dEwgBMGGyHQiy+DeozQMmzaACX4jseh1YFMZKec39rpEqxHcEM32CAK57IVgsrJSng7QbAvMEuOGaACjN5I5GPGSDEFg0AI3LzeJ0BCqZWe7z3cejJ3nKswwIRVVOQsOT42tugCQPkA+SIa8E8WmAxNmEAGFu9DWKacRDlrvn7NF4z4t9ZXjOA5/KJfQDLMW8A3B0df7fWfX1ASU/O2kIf4DlemJ+8bADH/oY+INIM/WvYcoE5cb8BHEYJlngVW95QHB5THO95HPrrA7D4p/YBloqtY/7FHM+/IY6K3IgBWDyRrRZWSkOfAlv7ABXHTnxogAozNGKR2zyxAUJs0QAwEm4ebgt7Ux8gnJxSqr+GrVyuxHER9Fw+8TaIGaNvJ5t9HNptgHyAHCMDkHgogqKzM5D05/UBD1hwJ1x9mjHNHEMLhMxdop4wQHlbNUBfjtk+ALJLTF7OAQOUPDsN8MCm+oCcrt8Ajv2L+wA7xdY4GEjFUWUeETVzP5GtNEAp0cfxnj7AY2yHQizuA5CjMEDi60cDMIxxrKN92m/pAwo2sslEmjlGPgVGDODGuj8x5hxd4hvzc9m+3e0j+wAoIk2xaAAYCTcPuoUJzeBr1MDeF/E57tHM0Qr89QHIswCI7Xocek8fcK1JmRTKveNxaNMALs0+zRxUHFXmOVG3Y8tbQ8DNxdj4kdugqT4gzzWJuKHtj4ojN0Dhv2gAl+ID+wAYMzOZ2EfO8aBmUmL/ZfllfQAcEQEok259HBrsgk0DKC7m12iNYwYIMWUAhfly8UZRinv2b30cOq+ZMnbCf1C7qw/IBD2ZP9cH5IOGyVtGgiIamzAAjG3tA4CjmbnhNkhtMiOaKXjBjmckWwxdzocYQGEjBjAo23ncWj//axG+D8goTh42AOPDdOCqv+FxaImPDfB8HaOfAm3DnORtUsCJL379cejvaxFY/Bu/FjGimTJGsHT6v4bdFnWJZymlsBTBOwyAeYNdcMwAFWbyRiIfM0CILRoARoLN41UGKJhc7aJmyhg3wDNc3BrFBvClGo4eEXCOP5uY2sm+4WsRKLAm5kh/3tciQgMQrj7NXs088NgAz9dBL96EAcrb6mJYjnkD4O7IDAAVP74P8BwvzE9eNoBj/5F9gCsSG8CEPw4ON0LP+zd+LeKOPgA5CgMkvv5hA7gU39wHFEyudlEzZSwwAZ6763f37VNcfNsAcDTg6K19gIpjJz40QIUZGrHIbZ7YACG2aAAYCTcPt4XtMgDh6n0Rn+MRzZSxcQM8XwePIyckEJEkqASc49ki+3ayO78WYZeCHCMDkHg76ERnZyBBbgDP0UQbfHcf8IAHDODS7NUM8ilpxvgcFosNUKWKCTYXY+O7nyYJA7DdkYkLMXk5BwxQ8uw0wAOb6gNyun4DOPZ39wH2B0zp04zmpNcdbXqlR/jKPsBjbIdC7JV9AMMYxzrap/19LcKPMbWK8xltKNfrkJ8CSliKYNPRjfm5bN/u9v6vRbBLbYtIU8wYAMa2fi3iw/qAUnbNAECfV7r0dTDiVFgm6fxiPqUPyEeUY2QAEm8HtSk46eS/FsFMWsUCfvdtUNMA19tdmkE+JU1g/Oh8Eg4HoGrabX2AyyEMYFB3PcTFUBfH/qg4cgMU/osGcCk29gGFkOTTZQAYMzNHDED4SN6m5KAJRg0gOJi/hq0dPb+Y6cehwS7YNIDiYn6N1jhmgBBTBlCYL0c3hs//WsSrDHCh0YYScbi4HtLRIwLO8WcTU2Te0Qc84nEtDSNBEY1NGADGtvYBwNHM3PA4VG0yo5p54P0GCPlUUPTpeSb8h0JM0vcZAHdHt/O4c7KvDyjpyX63tQ/IKE4eNgDjg6Zgr2//WsTsbdBTDzV6+AV1CDjxxaw/Dp3oAxQX+6PiKAyQ+PqHDeBS9N8GvbcPyAUxUhuA8JG8TUk2FpgAz92iAXz8899QEwL+nj6gwkzeSORjBgixRQPASLB5vMoABZOrXdRMGZs1gImMOQQGeP48xp8GnU1MkVl/HNowQD5AjrgWzBMLHkVnZyDpe/sA5OOFwIQVcCdcfZrJTS/HrxlA8WEU1eYRbF8pnfRLd32OfkcfwEyRjwYMUPLsNMADm3ocOmEAx/7XBzhMMCOntvq7Rq/rAzzGdijExh6HCgPkPLEBGMY41tE+7bf0AQUb2WRGNFPGAlniuYs2lIhDxVVuAYQj/btG3QYIyNz+OFRy5Cb4nj7AVdxnAMLV+yI+x5S3KblmAKBPKj1p7zHA88j9XaP39wHXDGWAfIAcIwOQeDvoRGdnOILJPw5lHKtYwO++DWoawKXBDQUmCQOU+P0GEGHSBMH2xTVTFc3fPh25DZrtAyB7NdckYnKo1tFngJJn0QAuxWQfkDnda4AyRwtu6Bw3DeCKCE563a/qAzxUsOP2PiAvwk1y2F/pA2AkvIhu+lsfhzaM6+i0DfCImthQIg4V13g9NiLa9Mh/UPPpFZnb+4B8EIu8aSQoIk0xYwAYm+4DLk7LBiBcfapYMJS3obRmgJBPBb3CAM8DuDW6wwAWqKnIe1T7o+Bv7wMy6sp9ah9AN6MkztluA5gp/QagHE7JTG6aBWKYLUhvjbS4+QIxBbtAiMW3QX0GKHkWDeBSbOwDCiHJp8sAMGZmjhiA8JG8TclBE4waQHE4Vfx4H6AMcya4NYrcuL8PqDC1GHfBxgwQYsoACvPl6Mag/sumOXprHwCVbzPAhUYbSsQhMAAMJzgrT5IEE9nO+q9hCzLv6AMe8Xi6ME/v4h0TnJ6aBoCx1dsgLwQmLMZd8/dpcNOASWrTy/FrBlB8ENplgDKmDGDjUR/8HwoRBjAo23ncOdnXB5T0vYsXImI7VLRrbTSAY3/349ApA7gi+/uAzJmbIKymznFHH2Ahi8X/hpowAE1NLsbH9wEKA/y9fUAuiJHaAISP5G1KsrFAlnjuFg3g408cTnTFg7dBbD6/NQp2wTEDdCyGXTCTJ15MiC0aAEb8RmHi4UJ+WB/geJuSOw3AKj1pv8oAJL6hGX9rJC62SzNigFLZZnnp49BfH+DprBlA8WEUvQkaBsgHvRshFDRQjKVU3xpVieqczACuHDGFJdhngJJnpwEe2K8PCOIlJ73ut/QBUHiHAZ6VD7tWeyHYDoVY3AcAvtgHMIxxrKN92m/pAwo2sslQ3qZk2wCPKHE+ow0l4lBxlVvAsKhFto5bZ8P8vP7L8kf2AVBELnDRADBSpfMYvZB4GzRjAMLV+yI+x5S3KblmAKBPKj1pv8oAnfGdazS3Ro4owXY9Dr2nD7gWqUwK5T71axF/pw9gKLsesQZ8WK9hxDqJZsifhWfGQFPMG6DkWTSAS7HxaxG7DABjZiZXUv85bhrAFbnGekzQaYDMuccAgI2IepcBYAE1w8OlIRdjrA+AauFY5P5gH0EDKMyXc4L/vD6gzFCbDOVtSs4a4EKjDSXiUHGN12MjYlGLbBN9AGGT38z/vK8N4KZ7wbAL1jISFNHYhAFg7CP7AJcqFgzlbSitGSDkU0Ef1wd44m0DXIfP3+it0ff1ARl15f4dj0MHDWCm9BuAcjglM7lpFohhjuCQAXJlphmYXIe4W6P4NqjPACXPogFcim9+HNowAOEjeZuSgyYYNYDicKr4yT4AcrZje9bINyR2XY/mCWGLcRdszAAhtmgAGOE72UsNUDC5Wu7kmwxwoYTjqgFgOMFZeZIkmMi2uQ/wEi/IEe4IjODAbVCvo6cNAGO/r0XUacb4MIpq8xgydArO2YJmythJTh9uKDjJ57b/UEiqF9RngFKod/FCRGyHinatjQZw7D+yD3BF9vcBmfPpMMGsLeoP6gO49h6/HOaEMIK/PkCvyV2MhgEIH8nblGRjgSzx3C0awMc3NFNIEkxke0Ef4CunvO5DG4BNO+WYdr88hdMGgJEqXbAb5l/vMEDBRgRDeZuSOw3AKj1pv8oAJH5XH3Ades8LE5wm6/PxKV6IyAAkHsiHJ4SwZQaweVy0wXf3AQ9YcFdcCWbxtgFK/JoBFB9G8Ru/FtE0gMpd/YKagb9rxA1QCu00wEUn2rWUAXK6fgM49nf3AfYHTFEGcEUEJ73ut/QBUPguAziG9LIIA1yAegDwD5ufJrMp2RoVAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dx",
    width: 3,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAACJJREFUCJljzMov+88ABSz/GeBsBpb//6Gc/wwMLBAJiAAAJS4KVAScxaIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dy",
    width: 165,
    height: 90,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dz",
    width: 5,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAABHNCSVQICAgIfAhkiAAAADFJREFUCJljjE3K/M8ABf8ZIEyW//8hXGTA8p/hP5IYVCXDP2SNMO0QUQT4DzcTVTsAwfEVKIIuLegAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dA",
    width: 5,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAALCAYAAAC3ZUeVAAAABHNCSVQICAgIfAhkiAAAAD1JREFUCJmNjkEKACAQAifw40EP6Md2KXCDIC+iOGDrY5qUjTIAGFCGIxV2Dwp+Bh84BXcxge8ORfe+ZGABwKUgoIcVEt8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dB",
    width: 16,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAVCAYAAABPPm7SAAAABHNCSVQICAgIfAhkiAAAAKxJREFUOI2Nk0sSwyAMQ9UZX7qLbnts1A2F+CNDNglYyM/Geb0/XwIAMF/zoV/6OPfKuJTpRGHiDUln0GR8fEe57aAWKSMiEfiToy1hEoy+UDD2JuSzJLrEXwTqFo59qHsQMmmItTCNXyNEiVWsXtQ3uRmkQ+q/wUnQ7pK5hBt8PoSyhJPR/hsPArlTE+iJ3OPmA6sH3kbcDLPGhsgqTYKubqIEyAHLtd7jg8APOXuPPSUk7aAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dC",
    width: 145,
    height: 75,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dD",
    width: 5,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAAChJREFUCJljzCoo+8+ABlgY/jMw/GdAFWf5/x9DIQMLuiqG/8gqkeQAPrUPVMPxlvAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dE",
    width: 8,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAABHNCSVQICAgIfAhkiAAAAE9JREFUGJV1jjkOgDAMBAfJn6ag5NsMRSISJ6aydr3XcV63ANAPGYXYURbwCZwe7qJAC+9gcsJSJBJP1T1R0TbWA7GomOPbhtVtFo2En5YX1HMsdYeyPb4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dF",
    width: 28,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAOCAYAAAA8E3wEAAAABHNCSVQICAgIfAhkiAAAAINJREFUOI290l0OgCAIAGDaOF237DpdCh/akOKv1PApG/ApuB3nTsBLfBrbaBH1YJ1G/A/N6h8gWUynkiqFU7cC/1aaYrAG6uBg+6I5RfmYxhjlnnOyD6BjACAHo/a9m8M9xgVXQwEYz2kUMsFsTrMYg3+1zwTJfWVrIQHWQAzWYVdeA28dT53KHBzrAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dG",
    width: 23,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAALCAYAAACUPhZAAAAABHNCSVQICAgIfAhkiAAAAGJJREFUKJFjnLTb+T8DAwMDA4RE0HDwH1MIA2BXwYIijqKGfEMRhuPQhF8bYWuxGE4dQ9EMpzwIsBpO2FjSDYXpwBHmlBkK4+GMUEoMxWE4Ja7FzCgs6ALUMBTJcOoEATYAAFgQLI/yYDbLAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dH",
    width: 159,
    height: 105,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dI",
    width: 198,
    height: 86,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dJ",
    width: 41,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAQCAYAAACLFVaTAAAABHNCSVQICAgIfAhkiAAAAHNJREFUSInV1dEJwCAMRdHb4n+H6izdf4T49UBoKZUYTe8A4RgFt/M6DMAIaMBQMyhZcW1l6LSQE49CBuHU7p4QDATPJifgVD9yIk71XfcCIHzd5CKcekcuxqlnZBKcur/JZEBoN5kQp0pmnPL/OBP6BbICvRET2CaYa0UAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dK",
    width: 225,
    height: 143,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dL",
    width: 4,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAAC1JREFUCJlty8EJACAUw9Cn/KXFARy7HkTwYE8JpG3MFYizugAS/ZWg5DT/i9insQ5+r8HLywAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dM",
    width: 9,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAABHNCSVQICAgIfAhkiAAAAEpJREFUGJWFzUEKwCAMRNGv5GIFl97/Or+LGkFp6yph8siUq3VRAESWfcx6Aggxow8gUk8A2epegEjkIdEOeOr+gUJkOD+O+gQAN6F+W4xXGH2MAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dN",
    width: 143,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAI8AAAAaCAYAAACOyA9jAAAABHNCSVQICAgIfAhkiAAABIxJREFUaIHtml2S4jAMhLVVnH1rT7DHxfsA2PrplpRgYKZ25iWMkthq+ZOlQH79/vN3yBf4G+PhxpDbx8fR2W4Xz6O+9+qumf9d78cxz67P/ujGH+tiYrM+jHGVNf28yV2jtOpPRjfWOI8oDkHPHDyco7F0GrUOr/UiX+AvBAaBdDuh1mLZrvejGeMOTbABWNZ8wAcK0uM6bbuGe+38yibWJw4N0g+0zin1XEBj0IM1Ymis7aPwZLsNW/AIjbUNkccWVASXABQCmJ3z0CybuHHhbkMhIEmjP1OQ5tR1sgzuSwekj8DTLlFJRvoSNUPnS1QRyG6J8r48BQ2CJNHqYbF+Dj91mnAUxsQXD81jorfCs7Ov0bZ2X6N92NnXAD939jVBq4eGaKW7lNOY9TXrGOP+NnjqvibPGNzXCC1RFCTkQwZSCC7ua6BGsT5FaJAtK0fIliRGodHqQja2ZrfPL4fnSF+DAln2NQE4ApK+97v2NXqhScJxrUnSUGhyjS+D52xfo+9t9zV38/a+RiSWqC40CJJEq4fF+ql3B6w1xKkoUd2+JnsC3g4PLEcIJC3KOZg9er+7r/Hj2Wua0CT3wnMVNJnGAhqsdc4Q/Us2ga3w8Il5YHRwjz56m1JVBQaUqrpELUBZJsa+JvpZJg2ymXPnk6XW2gfI69oCT6evieca0Mjgj94IJH0vCGDmi4Vm2Rg0asZGljb6GqdRTZ0mnB93d1/D1vPphvlwX7O8XSWqC83U7YPMoVmxBgE0gdjf16B78YIDaIhWBE0Yt+vLUWiA1lPwZFsczTZn6/Q12ulyq0Y2tEDmOpHyJwWtVZSfjcSAC52WXiF+Pt/XINtZaB7zHoYn/Z6GBqZRop74SSFt0mlw+7uNKjb4HAnuWDcVIM2pTyXLjhLVap5dnNrwnH30LqGRseUnheVesn0fhEZjk/YzXWiCnjl1mnB+3I4vXWjQeqa9ofKlhKcNjROq733qVQntA10MZPPB+n9eldjZ12gfxI2bwtOqjS4IesLv8qpE8CUNJLKxcrRIYY/era8SuuUoBYnHsoSGaITwtB7VkozZ+ZNCFtydfc2a8VhwZ3j9QsMdScx4tdYkaSqQkI6wrrlWqyvqNvA829eIfIGfFJ6BBkGSaPWwWD+HnxokTQQuwJj40oUGrWem1cYf+ylyh2dnX2Oc70KjfWhCg+790q9KZBoRjBQSfwRxPwqN8kHcuFSriFxaW1uSMbavUede8qpEFtwdr0rkwcWBZDYETS9ZrC5kY2uG4GJa7c7ifaHjq9hdIJ3lhB/4SaGEZtlmyLPdph1cAO6JEsW1JklDoSk0svUEWq1PQDdJuCHjtvPAEuWOevKP9zUisUR1oUGQJFp9ICk0RCtfjFwjBqTQ6KFJtKoB8x0WQPMQcAlOowHu5173qkSxQCZYP69KBI0daJQPfl2xfndcg0/bhQVGT/ieVyWQjZWoJaQlfg7rbQdKFITrfLL0S1QNUP690tLqfYl6cOzYxgB6ngY0Mn5elQDBDeMBWGqtj+sKjebe/BqrC/upI1duAvcx/gFBsIYYhEDhtwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dO",
    width: 4,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAACJJREFUCJljDA6P/c/wn4EBSjAwIXP+M/xnYELmMPxnYAAA1oMR/HlwqTcAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "dP",
    width: 123,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAAVCAYAAABmOZFVAAAABHNCSVQICAgIfAhkiAAAA3dJREFUaIHVmVuO5DAIRWmp9v896hXMKsN8JLZ5XDBOOx1Nq6WU8IvLMaBKff35/sv04h9zO57p/NieyMZ0PlittWOX9foXz26OxqI9tK2d13wY49cY+zlY6/ABaUVrlS+JVu7mYftMWDz2N4RnwWAn7rQCWx/TwpGth6hH3AYP2fxaCZmIiI8AUBUy1FPX6iC3udcFfAV2GoQQmgWPbDgY4b5FX2xWn3sI2yHXzYCjbI3Bh5dP7MFWq9R4tN1+GfZyya5CRpk7gYwyd7jnS7Z89vBeGVMu2aH+Bcgyi00MLeSe65ftV2CXIRtxci0sdQjyOZCM1fqyzf4xvqkvQ439dB8HoKcdP4Pc9ngc9rx/PVCeDajIl519GWqdQl7Xylar9OFAeobtMdhZNr/Vl1HJLvfl1Wx+qS93/8S+zYftsH/al8cjyTpOhAvI1ZId+7SpZGdaUz9BohjIzc+hH1yea/022Dv7srKFIAsZvKEva/8WIUONGvJMa09Ue8lti0GXR/hCu2CvBCMu2feC0SZb4CXwxAbyZTusjlhjDBnZalrZapW+HAgk0CAgN9uPYK/05Vh4Egx3QQLwZq0WDMArf43trb6MYig1ir48YjL2DS+52PcW7Lt9WTuFgjHJXDhWK9lR35QluwwZQc20pn76imAhX7MUZLdv5su1bgl2+UWBEYeEa1sRsjyvCNmulZCJ6JlXnItaFeQ2t11A6e8EMoqTbEVl2KXXf0aIB49seTCcDfkAypkOBijxHXJ3LNSYtZHpJQ+0MtDVP2dfpUCbqoBnKsCu9GU/VoAMbngU0Kxkl3zpe9wo2eFYoDXws2exjaHUOPkqVenLGrKOXQh7uS+33ZVTKBgAcjdHY7WSbQGO8RuQxwG+B4K1NoMjrYPJHLLbt+qLiV0bc7DT14vRbYY2GwwtHNlsmU7LMwooechEVOjL3s/pRV7QytbW5jIZPXPIOE7Ddog4aY0GdqmcOWj3wYf7Fn2xwdBlj/+bnx4HyH0lG+3xwQGdlOwqZJS5SLhxFN9qLFg+VfBWSnaofwGy0GFjWCnZFnLmSxWyXfs5ByaQjTgdPD3HiVPOeNvOr1LLkMcBecnOSjfQOpggyMPfOyV71pcdO6H1M+/LJihIcLU8I8gISJI1bZ4KGtGmnx6RraaVrVbpw61XnDqZpC3uy7nWf+a9y+E9qAvBAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dQ",
    width: 5,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAACZJREFUCJljnDBpwX8GNMCELoBV8P///wwsyBwoi4EFmQNh/mcAAG1ZEMG0spfDAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "dR",
    width: 12,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAABHNCSVQICAgIfAhkiAAAAFBJREFUGJWVjkkKgEAMBEvJEwVv/v8X5SGZYRYvQiB0ujr0cd2PACI5H3vwowlNY4crUjo63PkhjDjcEc4/sEJMPRc4q1QxMxEb3IH22Sn4Ah8aZbg9CR8aAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: -581.041,
    y1: -98.991,
    x2: -602.936,
    y2: -98.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#3E6722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cF",
    x1: -572.851,
    y1: -79.291,
    x2: -574.002,
    y2: -71.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#3E6722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: -640.749,
    y1: -88.806,
    x2: -652.121,
    y2: -69.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F919F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454A4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: -665.391,
    y1: -123.117,
    x2: -692.964,
    y2: -75.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F919F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454A4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: -576.087,
    y1: -93.271,
    x2: -593.159,
    y2: -74.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F919F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454A4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cD",
    x1: -665.232,
    y1: -86.771,
    x2: -665.654,
    y2: -73.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#3E6722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -591.224,
    y1: -117.504,
    x2: -594.636,
    y2: -91.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F919F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454A4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -441.502,
    y1: -76.994,
    x2: -1401.51,
    y2: -76.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#668D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E5408"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -449.106,
    y1: -78.323,
    x2: -1414.66,
    y2: -78.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EA61E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25630A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -448.554,
    y1: -78.222,
    x2: -1413.7,
    y2: -78.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EB623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -438.002,
    y1: -76.376,
    x2: -1395.45,
    y2: -76.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#225C09"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeBgStone2);
export default __webpack_public_path__ + "static/media/practice-bg-stone2.dec05058c045b6201a1f2000904a373c.svg";
export { ForwardRef as ReactComponent };